<div class="container pt-3 pb-3">
  <rbb-side-menu-headline [headline]="id === 'new' ? 'Neues Formular' : 'Formular bearbeiten'"
                          icon="fas fa-file-alt"/>

  <rbb-steps [steps]="steps" [current]="currentStep"/>

  @if (form) {
    @switch (currentStep) {
      @case (1) {
        <div class="alert alert-secondary small">
          <h4 class="mb-3">Hinweise</h4>
          <p class="fw-bold mb-3">Alle Eingaben und Änderungen werden nicht automatisch oder zwischengespeichert. Die
            Speicherung erfolgt erst am Ende.</p>
          <p class="fw-bold mb-3">Die Formulare können von Mitarbeiterinnen und Mitarbeiter von rbb, HSB, IVZ, ARD POC,
            ARD-Text und ARD-Generalsekretariat ausgefüllt werden. Andere Töchter, GSEA oder Anstalten können das System
            nicht nutzen.</p>
          <h5>Datenschutz</h5>
          <p>Alle Formulare müssen auf Grundlage der DSGVO von der Datenschutzbeauftragten überprüft werden. Bei einer
            Erstveröffentlichung im produktiven System von rbb Forms wird beim Abspeichern des Formulars die
            Datenschutzbeauftragte automatisch informiert. Sie muss das Formular überprüfen und final freigeben. Die
            Überprüfung kann erneut erfolgen, wenn datenschutzrelevante Änderungen am Formular vorgenommen werden. Dieser
            Prozess ist erforderlich und <span class="fw-bold text-underline">darf nicht umgangen werden</span>, um die
            Einhaltung der DSGVO zu gewährleisten. Auf dem Testsystem erfolgt keine Überprüfung durch die
            Datenschutzbeauftragte. Falls nötig wenden Sie sich bitte schon während der Formularerstellung an die
            Datenschutzbeauftragte Nicoleta-Simina Constantin <a
              href="mailto:datenschutz@rbb-online.de">datenschutz&#64;rbb-online.de</a>.</p>
        </div>
        <h4 class="my-3">Allgemeines</h4>
        <div class="row">
          <div class="col-6">
            <div class="form-group mb-3">
              <label for="name">Anzeigename <sup class="text-primary">*</sup></label>
              <input type="text" class="form-control form-control-sm" id="name" name="name" [(ngModel)]="form.name"
                     (change)="createTag()">
              @if (error && !form.name) {
                <div class="text-danger small">
                  Dies ist ein Pflichtfeld.
                </div>
              }
            </div>
          </div>
          <div class="col-6">
            <div class="form-group mb-3">
              <label for="groupName">Kategorie <sup class="text-primary">*</sup></label>
              <div class="input-group input-group-sm mb-2">
                <select class="form-select form-select-sm" name="groupName" id="groupName" [(ngModel)]="form.groupName">
                  <option>Compliance</option>
                  <option>Einkauf</option>
                  <option>Finanzen</option>
                  <option>Gebäudemanagement</option>
                  <option>IT für Administratoren und Projektleiter</option>
                  <option>IT für Anwender</option>
                  <option>Lizenzen</option>
                  <option>Personal</option>
                  <option>Produktion und Betrieb</option>
                </select>
              </div>
              @if (error && !form.groupName) {
                <div class="text-danger small">
                  Dies ist ein Pflichtfeld.
                </div>
              }
            </div>
          </div>
          <div class="col-6">
            <div class="form-group mb-3">
              <label for="name">Tag <sup class="text-primary">*</sup></label>
              <input type="text" [disabled]="id !== 'new' && transferSystems.length === 0"
                     class="form-control form-control-sm" id="tag" name="tag" [(ngModel)]="form.tag"
                     (keydown)="checkTag()" (keyup)="checkTag()">
              <span class="small text-secondary d-block mb-3 description-badge"><i
                class="fas fa-arrow-right"></i>&ensp;{{webUrl}}/tag/{{form.tag}}</span>
              @if (error && !form.tag) {
                <div class="text-danger small">
                  Dies ist ein Pflichtfeld.
                </div>
              }
            </div>
          </div>
          <div class="col-6">
            <div class="mb-3">
              <span class="small text-secondary d-block mb-3 description-badge"><i class="fas fa-info"></i>&ensp;Der Tag dient als eindeutige ID. Daraus wird zum Beispiel eine permanente URL erstellt, die auf die aktuelle Version des Formulars zeigt. Der Tag darf nur aus Kleinbuchstaben und Bindestrichen bestehen und kann nicht verändert werden.</span>
            </div>
          </div>
        </div>
        <h4 class="my-3">Berechtigungen</h4>
        <div class="row">
          <div class="col-6">
            <div class="form-group mb-3">
              <label>Verantwortliche <sup class="text-primary">*</sup></label>
              <rbb-people-picker [(ngModel)]="owners" (ngModelChange)="ownersChanged()" size="sm"/>
              <span class="small text-secondary d-block mb-3 description-badge"><i class="fas fa-info"></i>&ensp;Können dieses Formular verändern und ausgefüllte Anträge einsehen und bearbeiten.</span>
              @if (error && !form.owners?.length) {
                <div class="text-danger small">
                  Dies ist ein Pflichtfeld.
                </div>
              }
            </div>
          </div>
          <div class="col-6">
            <div class="form-group mb-3">
              <label>Bearbeiter/innen</label>
              <rbb-people-picker [(ngModel)]="operators" (ngModelChange)="operatorsChanged()"
                                 size="sm"/>
              <span class="small text-secondary d-block mb-3 description-badge"><i class="fas fa-info"></i>&ensp;Können nur die ausgefüllten Anträge einsehen und bearbeiten.</span>
            </div>
            <div class="form-check form-switch mb-3">
              <input type="checkbox" class="form-check-input" id="showLastOperator" name="showLastOperator" [(ngModel)]="form.showLastOperator">
              <label class="form-check-label" for="showLastOperator">Letzte/n Bearbeiter/in im Antrag anzeigen</label>
            </div>
            <div class="form-check form-switch mb-3">
              <input type="checkbox" class="form-check-input" id="allowCancelUntilProgressStarts" name="allowCancelUntilProgressStarts" [(ngModel)]="form.allowCancelUntilProgressStarts">
              <label class="form-check-label" for="allowCancelUntilProgressStarts">Erlaube Stornierung bis zum Bearbeitungsbeginn</label>
            </div>
          </div>
          <div class="col-6">
            <div class="form-group mb-3">
              <label>Leser/innen</label>
              <rbb-people-picker [(ngModel)]="readers" (ngModelChange)="readersChanged()" size="sm"/>
              <span class="small text-secondary d-block mb-3 description-badge"><i class="fas fa-info"></i>&ensp;Können nur die ausgefüllten Anträge einsehen.</span>
            </div>
          </div>
          <div class="col-6">
            <div class="form-group mb-3">
              <label>Tester/innen</label>
              <rbb-people-picker [(ngModel)]="tester" (ngModelChange)="testerChanged()" size="sm"/>
              <span class="small text-secondary d-block mb-3 description-badge"><i class="fas fa-info"></i>&ensp;Können nicht veröffentlichte Formulare ausfüllen und testen.</span>
            </div>
          </div>
          @if (admin || form.visibleForGroups?.length) {
            <div class="col-6">
              <div class="form-group mb-3">
                <label>AD-Gruppen-Beschränkung</label>
                <rbb-multi-value-input prependIcon="fas fa-users" [(ngModel)]="form.visibleForGroups" size="sm"/>
                <span class="small text-secondary d-block mb-3 description-badge"><i class="fas fa-info"></i>&ensp;Formular kann nur von Mitgliedern dieser Gruppen ausgefüllt werden.</span>
              </div>
            </div>
          }
        </div>

        <h4 class="my-3">Sichtbarkeit</h4>
        <div class="row">
          <div class="col-12">
            <span class="small text-secondary d-block mb-3 description-badge"><i class="fas fa-info"></i>&ensp;Wenn das Formular veröffentlicht wird, können alle rbb Mitarbeiterinnen und Mitarbeiter es aufrufen und ausfüllen. Wenn Sie erstmal nur testen wollen, benutzen Sie bitte unser Testsystem für Fachabteilungen: <a
              target="_blank" href="https://tools-s.rbb-online.de/forms">https://tools-s.rbb-online.de/forms</a>. Bei einer Erstveröffentlichung wird beim Abspeichern des Formulars die Datenschutzbeauftragte informiert. Sie muss das Formular überprüfen und final freigeben. Die Überprüfung kann erneut erfolgen, wenn datenschutzrelevante Änderungen am Formular vorgenommen werden. <span
              class="fw-bold text-underline">Dieser Prozess ist erforderlich und darf nicht umgangen werden</span>, um die Einhaltung der DSGVO zu gewährleisten. Auf dem Testsystem erfolgt keine Überprüfung durch die Datenschutzbeauftragte.</span>
            <div class="form-check form-switch mb-3">
              <input type="checkbox" class="form-check-input" id="visible" name="visible" [(ngModel)]="form.visible">
              <label class="form-check-label" for="visible">
                @if (form.visible) {
                  <span class="text-success fw-bold">Formular ist veröffentlicht</span>
                } @else {
                  <span class="text-danger fw-bold">Formular ist nicht veröffentlicht</span>
                }
              </label>
            </div>
          </div>
        </div>

        <h4 class="my-3">Informationen zur Fachabteilung</h4>
        <span class="small text-secondary d-block mb-3 description-badge"><i class="fas fa-info"></i>&ensp;Bitte geben Sie die verantwortliche <span
          class="text-underline">Hauptabteilung</span> für dieses Formular an. Die Hauptabteilung wird als verantwortliche Fachabteilung im Formular und in der Datenschutzerklärung angezeigt. Falls es keine Haupabteilung gibt, geben Sie bitte eine äquivalente Abteilung an. Des Weiteren muss im Formular eine E-Mail-Adresse angegeben werden, an der sich die Mitarbeiter wenden können, wenn sie fachliche Fragen zum Formular haben. Die Kontaktinformationen werden am Anfang des Formulars zusammen mit den Kontaktinformationen des zentralen ServiceDesks der HA Mediensysteme und IT als technischer Ansprechpartner angezeigt.</span>
        <div class="row">
          <div class="col-md-6">
            <label for="orgUnitType">Abteilung oder Hauptabteilung <sup class="text-primary">*</sup></label>
            <div class="input-group input-group-sm mb-2">
              <select class="form-select form-select-sm" name="orgUnitType" id="orgUnitType"
                      [(ngModel)]="form.orgUnitType">
                <option value="MAIN_DEPARTMENT">Hauptabteilung</option>
                <option value="DEPARTMENT">Abteilung</option>
              </select>
            </div>
            @if (error && !form.orgUnitType) {
              <div class="text-danger small">
                Dies ist ein Pflichtfeld.
              </div>
            }
          </div>
          <div class="col-md-6">
            <div class="form-group form-group-sm mb-2">
              <label for="orgUnitName">Name der Fachabteilung <sup class="text-primary">*</sup></label>
              <input type="text" class="form-control form-control-sm" id="orgUnitName" name="orgUnitName"
                     [(ngModel)]="form.orgUnitName">
              @if (error && !form.orgUnitName) {
                <div class="text-danger small">
                  Dies ist ein Pflichtfeld.
                </div>
              }
            </div>
          </div>
          <div class="col-6">
            <div class="form-group mb-3">
              <label for="contactEmail">E-Mail <sup class="text-primary">*</sup></label>
              <input type="email" class="form-control form-control-sm" id="contactEmail" name="contactEmail"
                     [(ngModel)]="form.contactEmail">
              @if (error && !form.contactEmail) {
                <div class="text-danger small">
                  Dies ist ein Pflichtfeld.
                </div>
              }
            </div>
          </div>
          <div class="col-6">
            <div class="form-group mb-3">
              <label for="contactTelephone">Telefon</label>
              <input type="text" class="form-control form-control-sm" id="contactTelephone" name="contactTelephone"
                     [(ngModel)]="form.contactTelephone">
            </div>
          </div>
        </div>

        <h4 class="my-3">Speicherdauer</h4>
        <span class="small text-secondary d-block mb-3 description-badge"><i class="fas fa-info"></i>&ensp;Es muss eine Speicherdauer angegeben werden. In rbb Forms werden alle Anträge entsprechend dieser Speicherdauer aufbewahrt. Die Speicherdauer gilt bis zum Ende des Kalenderjahres plus die angegebene Anzahl an Jahren. Sie sind als verantwortlicher Fachbereich zuständig die rechtlichen Aufbewahrungsfristen für das Formular zu ermitteln. Die allgemeine minimale Aufbewahrungsfrist beträgt 6 Jahre. Formulare können je nach Zweck eine deutlich höhere Aufbewahrungsfrist haben. Bitte beachten Sie dafür die <a
          href="https://intranet.rbb-online.de/grundlagen/handbuch-regelungen/datenschutz-und-informationssicherheit/dienstanweisung_informationssicherheit11111111111.file.html/Anlage%2010%20-%20Aufbewahrungsfristen.pdf"
          target="_blank">Dienstanweisung Informationsmanagement: Anlage 10 - Aufbewahrungsfristen</a></span>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group form-group-sm mb-2">
              <label for="storagePeriod">Speicherdauer in Jahren <sup class="text-primary">*</sup></label>
              <input type="number" [min]="admin ? 1 : 6" max="100" class="form-control form-control-sm" id="storagePeriod"
                     name="storagePeriod" [(ngModel)]="form.storagePeriod">
              @if (error && !form.storagePeriod) {
                <div class="text-danger small">
                  Dies ist ein Pflichtfeld.
                </div>
              }
              @if (error && form.storagePeriod && form.storagePeriod < 6) {
                <div class="text-danger small">
                  Die Speicherdauer muss mindestens 6 Jahre sein.
                </div>
              }
            </div>
          </div>
        </div>

        <h4 class="my-3">Genehmigungsweg</h4>
        <span class="small text-secondary d-block mb-3 description-badge"><i class="fas fa-info"></i>&ensp;Wenn die Genehmigungsreihenfolge aktiviert ist, müssen die Genehmigungen nach der unten stehenden Reihenfolge erfolgen. Wenn die Genehmigungsreihenfolge deaktiviert ist, werden alle Genehmiger gleichzeitig benachrichtigt und können parallel genehmigen.</span>
        <div class="row">
          <div class="col-12">
            <div class="form-check form-switch mb-3">
              <input type="checkbox" class="form-check-input" id="orderedApprovals" name="orderedApprovals"
                     [(ngModel)]="form.orderedApprovals">
              <label class="form-check-label" for="orderedApprovals">
                @if (form.orderedApprovals) {
                  <span class="text-success fw-bold">Genehmigungsreihenfolge aktiviert</span>
                } @else {
                  <span class="text-danger fw-bold">Genehmigungsreihenfolge deaktiviert</span>
                }
              </label>
            </div>
          </div>
          @if (form.approverTypes) {
            @for (ignored of form.approverTypes; let i = $index; track i) {
              <div class="col-md-6 pt-2">
                <div class="input-group input-group-sm mb-2">
                  <label class="input-group-text" for="appType{{i}}"><i class="fas fa-file-signature"
                                                                        aria-hidden="true"></i></label>
                  <select class="form-select form-select-sm" id="appType{{i}}" name="appType{{i}}"
                          [(ngModel)]="form.approverTypes[i]" [attr.aria-label]="'Genehmiger ' + i">
                    @for (approverType of getAllApproverTypeValues(); track approverType) {
                      @if (isApproverTypeAvailable(approverType, i)) {
                        <option [value]="approverType">{{getLocalizedNameOfApproverType(approverType)}}</option>
                      }
                    }
                  </select>
                </div>
                @if (i !== form.approverTypes.length - 1) {
                  <div class="row">
                    <div class="col"></div>
                    @if (form.orderedApprovals) {
                      <div class="col-auto"><i class="fas fa-arrow-down"></i></div>
                    } @else {
                      <div class="col-auto">&#x200B;</div>
                    }
                    <div class="col"></div>
                  </div>
                }
              </div>

              @if (form.approverDataCustomParameter && form.approverDataCustomParameter[i]) {
                <div class="col-md-6 pb-2 pt-2">
                  <div class="col-md-6">
                    <div class="form-check mb-2">
                      <input class="form-check-input" [(ngModel)]="form.approverDataCustomParameter[i].forInformationOnly"
                             type="checkbox" value="" id="mailNotification{{i}}">
                      <label class="form-check-label" for="mailNotification{{i}}">
                        Zur Kenntnisnahme <br><small> Genehmiger kann den Antrag nicht ablehnen.</small>
                      </label>
                    </div>
                  </div>
                </div>
              }

              @if (form.approverDataCustomParameter && form.approverDataCustomParameter[i] && (form.approverTypes[i] === 'DESIGNATED_APPROVER' || form.approverDataCustomParameter[i].forInformationOnly)) {
                <div class="col-md-6"></div>
                <div class="col-md-3 pb-2">
                  <div class="input-group input-group-sm">
                    <label class="input-group-text">
                      <i class="fas fa-calendar"></i>
                    </label>
                    <input type="number" class="form-control" min="7" max="30"
                           [(ngModel)]="form.approverDataCustomParameter[i].limit">
                  </div>
                  <div class="small">Tage zur Kenntnisnahme</div>
                </div>
                <div class="col-md-3 pb-2">
                  @if (form.approverDataCustomParameter[i].forInformationOnly) {
                    Der Antrag wird automatisch nach x Tagen zur Kenntnis genommen.
                  } @else {
                    Wenn das Feld gesetzt ist, wird die Genehmigung automatisch nach x Tagen erteilt.
                  }
                </div>
              }

              @if (form.approverDataCustomParameter && form.approverDataCustomParameter[i] && form.approverTypes && form.approverTypes[i] === 'APPROVER_GROUP') {
                <div class="col-md-6 pb-2"></div>
                <div class="col-md-6 pb-2">
                  <rbb-people-picker [(ngModel)]="form.approverDataCustomParameter[i].groupMembers" size="sm"
                                     [max]="0"/>
                  <div class="small">mindestens 3 Personen müssen eine Gruppe bilden <sup class="text-primary">*</sup></div>
                  @if (error && form.approverTypes && form.approverTypes[i] === 'APPROVER_GROUP' && (!form.approverDataCustomParameter[i].groupMembers.length ||  form.approverDataCustomParameter[i].groupMembers.length < 2)) {
                    <div class="text-danger small">
                      Dies ist ein Pflichtfeld und benötigt mehr als 2 Personen.
                    </div>
                  }
                </div>
                <div class="col-md-6"></div>
                <div class="col-md-6">
                  <div class="form-check mb-2">
                    <input class="form-check-input" [(ngModel)]="form.approverDataCustomParameter[i].mailNotification"
                           type="checkbox" value="" id="mailNotification{{i}}">
                    @if (form.approverDataCustomParameter[i].mailNotification) {
                      <label class="form-check-label text-success" for="mailNotification{{i}}">
                        E-Mail Benachrichtigung aktiviert <br><small> Jedes Mitglied wird bei einem Antrag mit einer
                        E-Mail informiert.</small>
                      </label>
                    } @else {
                      <label class="form-check-label text-darkgray" for="mailNotification{{i}}">
                        E-Mail Benachrichtigung deaktiviert <br><small> Kein Mitglied wird über Mail bei einem neuen
                        Antrag informiert.</small>
                      </label>
                    }
                  </div>
                </div>
              }

              @if (form.approverDataCustomParameter && form.approverDataCustomParameter[i] && form.approverTypes && form.approverTypes[i] === 'DESIGNATED_APPROVER') {
                <div class="col-md-6 pb-2"></div>
                <div class="col-md-3 pb-2">
                  <rbb-people-picker [(ngModel)]="form.approverDataCustomParameter[i].users"
                                     size="sm" [max]="1"/>
                  <div class="small">Genehmiger/in <sup class="text-primary">*</sup></div>
                  @if (error && form.approverTypes && form.approverTypes[i] === 'DESIGNATED_APPROVER' && !form.approverDataCustomParameter[i].users.length) {
                    <div class="text-danger small">
                      Dies ist ein Pflichtfeld.
                    </div>
                  }
                </div>
                <div class="col-md-3 pb-2">
                  <rbb-people-picker [(ngModel)]="form.approverDataCustomParameter[i].deputyUsers"
                                     size="sm" [max]="1"/>
                  <div class="small">Vertreter/in (optional)</div>
                </div>
              }
            }
          }
          <div class="col-md-6">
            @if (!form.approverTypes || form.approverTypes.length === 0) {
              <p>Es gibt keinen Genehmigungsweg für dieses Formular!</p>
            }
            <div class="row">
              <div class="col">
                <hr class="m-0 p-0 hr-custom">
              </div>
              <div class="col-auto">
                <button type="button" class="btn btn-sm btn-outline-success me-2"
                        [disabled]="(form.approverTypes?.length ?? 0) > 8" (click)="addApproverType()"
                        aria-label="Genehmiger hinzufügen"><i class="fas fa-plus" aria-hidden="true"></i></button>
                <button type="button" class="btn btn-sm btn-outline-danger"
                        [disabled]="(form.approverTypes?.length ?? 0) < 1" (click)="removeApproverType()"
                        aria-label="Genehmiger entfernen"><i class="fas fa-minus" aria-hidden="true"></i></button>
              </div>
              <div class="col">
                <hr class="m-0 p-0 hr-custom">
              </div>
            </div>
          </div>
        </div>

        <h4 class="my-3">Vorgangstyp</h4>
        <div class="row">
          <span class="small text-secondary d-block mb-3 description-badge"><i class="fas fa-info"></i>&ensp;Wenn ein Antrag ausgefüllt und genehmigt wurde, kann er an ein System zur weiteren Bearbeitung weitergeleitet werden. Wenn der Antrag nicht weitergeleitet wird, muss die Fachabteilung den Status der Bearbeitung pro Antrag in rbb Forms hinterlegen. Wenn eine Weiterleitung ausgewählt wird, müssen die benötigten Zusatzinformationen angegeben werden.</span>
          <div class="col-md-4">
            <div class="input-group input-group-sm mb-3">
              <select class="form-select form-select-sm" [(ngModel)]="form.actionType"
                      (ngModelChange)="changeActionType()" aria-label="Vorgangstyp">
                <option [ngValue]="null">Keine Weiterleitung</option>
                <option [ngValue]="'EMAIL'">E-Mail Benachrichtigung</option>
                <option [ngValue]="'EMAIL_DATA'">E-Mail Datenübermittlung</option>
                @if (form.actionType === ActionType.OTRS) {
                  <option [ngValue]="'OTRS'">OTRS (EMAIL) Vorgang (nur für HA MIT)</option>
                }
                @if (admin || form.actionType === ActionType.OTRS_WEBSERVICE) {
                  <option [ngValue]="'OTRS_WEBSERVICE'">OTRS (WEB) Vorgang (nur für HA MIT)</option>
                }
                @if (admin || form.actionType === ActionType.WEBHOOK) {
                  <option [ngValue]="'WEBHOOK'">Webhook</option>
                }
                @if (admin || form.actionType === ActionType.NO) {
                  <option [ngValue]="'NO'">Keine Bearbeitung oder Weiterleitung</option>
                }
              </select>
            </div>
            @if (form.actionType === ActionType.OTRS_WEBSERVICE) {
              <span class="small text-secondary d-block mb-3 description-badge"><i
                class="fas fa-info"></i>&ensp;Bitte kontaktiere <a
                href="mailto:mit-servicedesk_und_servicemanagement@rbb-online.de">mit-servicedesk_und_servicemanagement&#64;rbb-online.de</a>, um das weitere Vorgehen in OTRS abzustimmen.</span>
            }
          </div>
          @if (form.actionType === ActionType.EMAIL && form.actionDataCustomParameter) {
            <div class="col-md-8">
              <div class="input-group input-group-sm">
                <input type="text" class="form-control form-control-sm" id="emailAddress" name="emailAddress"
                       placeholder="E-Mail des Ziels" aria-label="E-Mail des Ziels"
                       [(ngModel)]="form.actionDataCustomParameter.emailAddress">
              </div>
              @if (error && !form.actionDataCustomParameter.emailAddress) {
                <div class="text-danger small">
                  Dies ist ein Pflichtfeld.
                </div>
              }
            </div>
          }
          @if (form.actionType === ActionType.EMAIL_DATA && form.actionDataCustomParameter) {
            <div class="col-md-8">
              <div class="input-group input-group-sm">
                <input type="text" class="form-control form-control-sm" id="emailDataAddress" name="emailDataAddress"
                       placeholder="E-Mail des Ziels" aria-label="E-Mail des Ziels"
                       [(ngModel)]="form.actionDataCustomParameter.emailAddress">
              </div>
              @if (error && !form.actionDataCustomParameter.emailAddress) {
                <div class="text-danger small">
                  Dies ist ein Pflichtfeld.
                </div>
              }
              <div class="form-check mt-2">
                <input type="checkbox" class="form-check-input" id="includeDescriptionFields" name="includeDescriptionFields"
                       [(ngModel)]="form.actionDataCustomParameter.includeDescriptionFields">
                <label class="form-check-label" for="includeDescriptionFields">Beschreibungsfelder in der Mail behalten</label>
              </div>
            </div>
          }
          @if (form.actionType === ActionType.OTRS && form.actionDataCustomParameter) {
            <div class="col-md-8">
              <div class="input-group input-group-sm">
                <select class="form-select form-select-sm" id="otrsEmailAddress" name="otrsEmailAddress"
                        aria-label="OTRS E-Mail"
                        [(ngModel)]="form.actionDataCustomParameter.emailAddress">
                  @if (dataProtectionOfficer) {
                    <option value="support@ardzsd.de">
                      support&#64;ardzsd.de
                    </option>
                  }
                  <option value="support@int.ardzsd.de">support&#64;int.ardzsd.de</option>
                  <option value="support@dev.ardzsd.de">support&#64;dev.ardzsd.de</option>
                </select>
              </div>
              @if (error && !form.actionDataCustomParameter.emailAddress) {
                <div class="text-danger small">
                  Dies ist ein Pflichtfeld.
                </div>
              }
              <div class="input-group input-group-sm mt-3">
                <input type="text" class="form-control form-control-sm" id="subjectTag" name="subjectTag"
                       placeholder="Eindeutiger Wert für den E-Mail Betreff"
                       aria-label="Eindeutiger Wert für den E-Mail Betreff"
                       [(ngModel)]="form.actionDataCustomParameter.subjectTag">
              </div>
              @if (error && !form.actionDataCustomParameter.subjectTag) {
                <div class="text-danger small">
                  Dies ist ein Pflichtfeld.
                </div>
              }
            </div>
          }
          @if (form.actionType === ActionType.OTRS_WEBSERVICE && form.actionDataCustomParameter) {
            <div class="col-md-8">
              <div class="input-group input-group-sm">
                <label class="input-group-text same-prepend-width" data-prepend-width-group="1" for="otrsUrl">Instanz</label>
                <select class="form-select form-select-sm" id="otrsUrl" name="otrsUrl"
                        aria-label="OTRS URL" [disabled]="!admin"
                        [(ngModel)]="form.actionDataCustomParameter.url">
                  @if (dataProtectionOfficer) {
                    <option value="https://ardzsd.de">
                      https://ardzsd.de
                    </option>
                  }
                  <option value="https://int.ardzsd.de">https://int.ardzsd.de</option>
                  <option value="https://dev.ardzsd.de">https://dev.ardzsd.de</option>
                </select>
              </div>
              @if (error && !form.actionDataCustomParameter.url) {
                <div class="text-danger small">
                  Dies ist ein Pflichtfeld.
                </div>
              }
              <div class="input-group input-group-sm mt-3">
                <label class="input-group-text same-prepend-width" data-prepend-width-group="1" for="title">Titel</label>
                <textarea type="text" class="form-control form-control-sm font-monospace" id="title" name="title" [disabled]="!admin" rows="3"
                       [(ngModel)]="form.actionDataCustomParameter.title"></textarea>
              </div>
              @if (error && !form.actionDataCustomParameter.title) {
                <div class="text-danger small">
                  Dies ist ein Pflichtfeld.
                </div>
              }
              <div class="input-group input-group-sm mt-3">
                <label class="input-group-text same-prepend-width" data-prepend-width-group="1" for="type">Type</label>
                <textarea type="text" class="form-control form-control-sm font-monospace" id="type" name="type" [disabled]="!admin" rows="3"
                       [(ngModel)]="form.actionDataCustomParameter.type"></textarea>
              </div>
              @if (error && !form.actionDataCustomParameter.type) {
                <div class="text-danger small">
                  Dies ist ein Pflichtfeld.
                </div>
              }
              <div class="input-group input-group-sm mt-3">
                <label class="input-group-text same-prepend-width" data-prepend-width-group="1" for="service">Service</label>
                <textarea type="text" class="form-control form-control-sm font-monospace" id="service" name="service" [disabled]="!admin" rows="3"
                       [(ngModel)]="form.actionDataCustomParameter.service"></textarea>
              </div>
              @if (error && !form.actionDataCustomParameter.service) {
                <div class="text-danger small">
                  Dies ist ein Pflichtfeld.
                </div>
              }
              <div class="input-group input-group-sm mt-3">
                <label class="input-group-text same-prepend-width" data-prepend-width-group="1" for="queue">Queue</label>
                <textarea type="text" class="form-control form-control-sm font-monospace" id="queue" name="queue" [disabled]="!admin" rows="3"
                          [(ngModel)]="form.actionDataCustomParameter.queue"></textarea>
              </div>
              @if (error && !form.actionDataCustomParameter.queue) {
                <div class="text-danger small">
                  Dies ist ein Pflichtfeld.
                </div>
              }
              <div class="input-group input-group-sm mt-3">
                <label class="input-group-text">Dynamische Felder</label>
                <textarea type="text" class="form-control form-control-sm font-monospace" id="dynamicFields" name="dynamicFields" rows="10"
                          [(ngModel)]="form.actionDataCustomParameter.dynamicFields" [disabled]="!admin"></textarea>
              </div>
              @if (error && !form.actionDataCustomParameter.dynamicFields) {
                <div class="text-danger small">
                  Dies ist ein Pflichtfeld.
                </div>
              }
              <div class="mt-3">
                Verfügbare Bedingungen
                <ul>
                  <li>DEFAULT</li>
                  @for (conditionalTerm of getAvailableConditionalTermsByDefinition({fields: form.fields, index: form.fields?.length}); track conditionalTerm) {
                    <li>{{conditionalTerm}}</li>
                  }
                </ul>
              </div>
            </div>
          }
          @if (form.actionType === ActionType.WEBHOOK && form.actionDataCustomParameter) {
            <div class="col-md-8">
              <div class="input-group input-group-sm">
                <input type="text" class="form-control form-control-sm" id="webhookUrl" name="webhookUrl"
                       placeholder="Webhook URL" aria-label="Webhook URL"
                       [(ngModel)]="form.actionDataCustomParameter.url">
              </div>
              @if (error && !form.actionDataCustomParameter.url) {
                <div class="text-danger small">
                  Dies ist ein Pflichtfeld.
                </div>
              }
              @if (error && form.actionDataCustomParameter.url && !form.actionDataCustomParameter.url.startsWith('https://')) {
                <div class="text-danger small">
                  Die URL muss mit https:// starten.
                </div>
              }
              <div class="input-group input-group-sm mt-3">
                <input type="text" class="form-control form-control-sm" id="webhookToken" name="webhookToken"
                       placeholder="Token" aria-label="Token"
                       [(ngModel)]="form.actionDataCustomParameter.token">
              </div>
              <div class="input-group input-group-sm mt-3">
                <input type="text" class="form-control form-control-sm" id="webhookBearer" name="webhookBearer"
                       placeholder="Bearer" aria-label="Bearer"
                       [(ngModel)]="form.actionDataCustomParameter.bearer">
              </div>
            </div>
          }
          @if (form.actionType === ActionType.EMAIL) {
            <span class="small text-secondary d-block mb-3 description-badge">
              <i class="fas fa-info"></i>&ensp;Bei der Benachrichtigung werden <span class="fw-bold text-underline">keine</span> Daten des Formulars übertragen.
              Es ist nur eine Information, dass ein neuer Antrag zur Bearbeitung bereit steht.
              Es <span class="fw-bold text-underline">muss</span> für diese Anträge der Status der Bearbeitung in rbb Forms hinterlegt werden.
            </span>
          }
        </div>
      }
      @case (2) {
        <h4 class="my-3">Datenfelder</h4>
        <p class="fw-bold">Hinweise zur Benutzerfreundlichkeit</p>
        <ol>
          <li>Bieten Sie möglichst vorausgefüllte Eingabefelder an. Dies verringert den Zeitaufwand, die mentale
            Anstrengung und mögliche Fehler von Benutzerinnen und Benutzer.
          </li>
          <li>Stellen Sie Auswahlfelder zur Verfügung, denn auch das erleichtert den Umgang mit dem Formular. Nutzen Sie
            dafür den Datentyp Auswahl.
          </li>
          <li>Verhindern Sie wenn möglich Freitextfelder. Sie sollten nur dort eingesetzt werden, wo sie zwingend nötig
            sind. Um Fehler durch Benutzerinnen und Benutzer zu vermeiden, nutzen Sie die weiteren Einschränkungsoptionen
            und geben Sie in der Beschreibung Beispiele an.
          </li>
          <li>Nutzen Sie einheitliche Begriffe für ein und dieselbe Sache.</li>
          <li>Verwenden Sie nur solche (Fach-) Begriffe/Abkürzungen/Symbole, die Ihren Benutzerinnen und Benutzern sicher
            bekannt sind.
          </li>
          <li>Formulare aus gleichen Abteilungen sollten ähnlich aufgebaut und strukturiert sein.</li>
          <li>Beschränken Sie sich auf das Wesentliche und gestalten Sie die Formulare so einfach wie möglich.</li>
        </ol>
        <p class="fw-bold">Formatierung der Schrift</p>
        <div>
          Sie können Systemzeichen benutzen, um die Namen der Felder und die Beschreibungstexte zu formatieren z.B.
          **Überschrift**<br/>** - <span class="fw-bold">fett</span><br/>## - <span class="fst-italic">kursiv</span><br/>_
          _ - <span class="text-decoration-underline">unterstrichen</span><br/>&#64;rot&#64; - <span
          class="text-primary">rot</span>
        </div>
        <div class="row bg-body py-3 position-sticky" [style.top.px]="52" [style.z-index]="100">
          <div class="col-12 text-end">
            <button class="btn btn-sm btn-primary" (click)="openModal()">Vorschau anzeigen</button>
            <a class="ms-2 btn btn-sm btn-primary" href="editor-live/{{form.id ?? 'null'}}" target="_blank">Live-Vorschau im neuen Fenster öffnen</a>
          </div>
        </div>
        <div class="row data-field-border py-2">
          @for (field of form.fields; track field; let i = $index) {
            @if (addPlusButton(i)) {
              <div class="col-12">
                <div class="row mb-4" [class.mt-2]="i === 0">
                  <div class="col">
                    <hr class="m-0 p-0 hr-custom field-plus-color">
                  </div>
                  <div class="col-auto">
                    <button type="button" class="btn btn-sm btn-outline-info" (click)="addField(i)"
                            aria-label="Auswahlmöglichkeit entfernen"><i class="fas fa-plus" aria-hidden="true"></i>
                    </button>
                  </div>
                  <div class="col">
                    <hr class="m-0 p-0 hr-custom field-plus-color">
                  </div>
                </div>
              </div>
            }
            <div class="drag-element col-md-{{fieldWidth(field)}} mb-4" style="position: relative">
              <div class="data-field-border px-3 pb-3 pt-2 h-100">
                <div class="row">
                  <div class="col-12">
                    <span class="fw-bold">Datenfeld {{field.order}} @if (field.name) {<span [innerHTML]="'(' + processStyleMarkupWithoutBreaks(field.name) + ')'"></span>}</span>
                    <div class="float-end d-inline-block">
                      <!--<i class="fas fa-arrows-alt d-inline-block transform grow-effect" style="cursor: grab" aria-hidden="true" aria-label="Datenfeld verschieben mit Maus verschieben" (mousedown)="startDrag($event)"></i>-->
                      <i class="d-inline-block pointer transform grow-effect far fa-caret-square-left ms-2"
                         aria-hidden="true" aria-label="Datenfeld nach vorne verschieben"
                         (click)="orderItem(field, -1)"></i>
                      <i class="d-inline-block pointer transform grow-effect far fa-caret-square-right ms-2"
                         aria-hidden="true" aria-label="Datenfeld nach hinten verschieben"
                         (click)="orderItem(field, 1)"></i>
                      <i class="d-inline-block pointer transform grow-effect fas fa-times ms-3 text-danger"
                         aria-hidden="true" aria-label="Datenfeld löschen" (click)="removeField(field)"></i>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group mb-2">
                      <label for="formField{{i}}Name" class="data-field-label">Name <sup
                        class="text-primary">*</sup></label>
                      <input type="text" class="form-control form-control-sm" [(ngModel)]="field.name"

                             id="formField{{i}}Name" name="formField{{i}}Name">
                      @if (field.type === FieldType.HEADER) {
                        <span class="small text-secondary d-block mb-3 description-badge"><i
                          class="fas fa-info"></i>&ensp;Der Name ist die angezeigte Überschrift.</span>
                      }
                      @if (field.type === FieldType.SEPARATOR_LINE || field.type === FieldType.DESCRIPTION || field.type === FieldType.BLANK_SPACE) {
                        <span class="small text-secondary d-block mb-3 description-badge"><i class="fas fa-info"></i>&ensp;Der Name wird nicht angezeigt, jedoch aus technischen Gründen benötigt.</span>
                      }
                      @if (error && !field.name) {
                        <div class="text-danger small">
                          Dies ist ein Pflichtfeld.
                        </div>
                      }
                    </div>
                  </div>
                  <div class="col-md-6">
                    <label for="formField{{i}}Type" class="data-field-label">Datentyp <sup
                      class="text-primary">*</sup></label>
                    <div class="input-group input-group-sm mb-2">
                      <select class="form-select form-select-sm" name="formField{{i}}Type" id="formField{{i}}Type"
                              [(ngModel)]="field.type" (ngModelChange)="changeCustomParameter(field)">
                        <optgroup label="Einfache Eingabefelder">
                          <option value="TEXT">Text</option>
                          <option value="NUMBER">Zahl</option>
                          <option value="PERCENT">Prozentrechnung</option>
                          <option value="YES_NO">Ja / Nein</option>
                          <option value="SELECTION">Auswahl (ein oder mehrere)</option>
                          <option value="SELECTION_PLUS">Auswahl mit zusätzlichem Freitext-Feld</option>
                          <option value="LIST">Ausfüllbare Liste</option>
                          <option value="EMAIL">E-Mail</option>
                          <option value="DATE">Datum</option>
                          <option value="TIME">Uhrzeit</option>
                          <option value="PERIOD">Zeitraum</option>
                          <option value="PERIODS">Zeiträume</option>
                          <option value="SELECTION_TABLE">Auswahltabelle (nur benutzen, wenn nötig)</option>
                          <option value="TABLE">Tabelle (nur benutzen, wenn nötig)</option>
                          <option value="FILE">Dateien (nur benutzen, wenn nötig)</option>
                        </optgroup>
                        <optgroup label="Eingabefelder mit Auswahlliste">
                          <option value="CLIENT">Computer</option>
                          <option value="ROOM">Raum</option>
                          <option value="COST_CENTRE">Kostenstelle</option>
                          <option value="ACCOUNT">Benutzerkonto</option>
                          <option value="PERSON">Person</option>
                          <option value="PERSON_LIST">Personenliste</option>
                          <option value="PRODUCTION_UNIT">Produktionseinheiten</option>
                        </optgroup>
                        <optgroup label="Vorausgefüllte Eingabefelder">
                          <option value="TELEPHONE">Telefon</option>
                          <option value="MOBILE">Mobiltelefon</option>
                          <option value="FAX">Fax</option>
                        </optgroup>
                        <optgroup label="Unveränderbare & vorausgefüllte Eingabefelder">
                          <option value="EMPLOYEE_TYPE">eigener Vertragstyp (Fest/Frei)</option>
                          <option value="EMPLOYEE_NUMBER">eigene Personalnummer</option>
                          <option value="ORG_UNIT">eigene Organisationseinheit</option>
                          <option value="MOBILE_WORK_AGREEMENT">Vereinbarung zum mobilen Arbeiten</option>
                          <option value="DISABILITY_STATUS">Schwerbehinderung</option>
                        </optgroup>
                        <optgroup label="Strukturelemente">
                          <option value="HEADER">Überschrift / Abtrennung (keine Eingabe)</option>
                          <option value="SEPARATOR_LINE">Trennlinie (keine Eingabe)</option>
                          <option value="DESCRIPTION">Beschreibung (keine Eingabe)</option>
                          <option value="BLANK_SPACE">Leerraum (keine Eingabe)</option>
                        </optgroup>
                        @if (admin) {
                          <optgroup label="Nutzerantrag">
                            <option value="GENERAL">_Allgemein</option>
                            <option value="APPLICATION">Applikationen</option>
                            <option value="BIMEDIAL">Bimedial</option>
                            <option value="CAD">CAD</option>
                            <option value="CONFLUENCE">Confluence</option>
                            <option value="FILESERVICE">Fileservice</option>
                            <option value="IT">IT</option>
                            <option value="JIRA">Jira</option>
                            <option value="MCLOUD">mCloud</option>
                            <option value="MUSIC_MASTER">MusicMaster</option>
                            <option value="PROJECT">Projekte</option>
                            <option value="RABBIT">r&commat;bbit</option>
                          </optgroup>
                        }
                      </select>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="form-group mb-2">
                      <label for="formField{{i}}Tag" class="data-field-label">Tag</label>
                      <input type="text" class="form-control form-control-sm" id="formField{{i}}Tag"
                             name="formField{{i}}Tag" [(ngModel)]="field.tag">
                    </div>
                  </div>
                  <div class="col-md-6">
                    @if (field.type !== FieldType.HEADER && field.type !== FieldType.SEPARATOR_LINE && field.type !== FieldType.TABLE && field.type !== FieldType.SELECTION_TABLE && field.type !== FieldType.BLANK_SPACE) {
                      <label for="formField{{i}}ColumnWidth" class="data-field-label">Zeilenbreite</label>
                      <div class="input-group input-group-sm mb-2">
                        <select class="form-select form-select-sm" name="formField{{i}}ColumnWidth"
                                id="formField{{i}}ColumnWidth" [(ngModel)]="field.columnWidth">
                          <option value="6">50% Breite</option>
                          <option value="12">100% Breite</option>
                        </select>
                      </div>
                    }
                  </div>
                  <div class="col-md-6 align-middle">
                    @if (field.type !== FieldType.HEADER && field.type !== FieldType.SEPARATOR_LINE && field.type !== FieldType.DESCRIPTION && field.type !== FieldType.BLANK_SPACE && field.type !== FieldType.ORG_UNIT && field.type !== FieldType.EMPLOYEE_NUMBER && field.type !== FieldType.EMPLOYEE_TYPE && field.type !== FieldType.MOBILE_WORK_AGREEMENT && field.type !== FieldType.DISABILITY_STATUS) {
                      <div class="form-check form-switch mb-2 mt-4">
                        <input type="checkbox" class="form-check-input" id="formField{{i}}Required"
                               name="formField{{i}}Required" [(ngModel)]="field.required" (change)="requiredChanged(field)">
                        <label class="form-check-label" for="formField{{i}}Required">Pflichtfeld</label>
                      </div>
                    }
                    @if (field.type === FieldType.NUMBER || field.type === FieldType.TEXT || field.type === FieldType.YES_NO || field.type === FieldType.DATE || field.type === FieldType.TIME || field.type === FieldType.PERIOD || field.type === FieldType.PERCENT || field.type === FieldType.ROOM || field.type === FieldType.COST_CENTRE || field.type === FieldType.ORG_UNIT || field.type === FieldType.EMPLOYEE_NUMBER || field.type === FieldType.EMPLOYEE_TYPE || field.type === FieldType.MOBILE_WORK_AGREEMENT || field.type === FieldType.DISABILITY_STATUS || field.type === FieldType.CLIENT || field.type === FieldType.TELEPHONE || field.type === FieldType.MOBILE || field.type === FieldType.FAX || field.type === FieldType.EMAIL || field.type === FieldType.SELECTION || field.type === FieldType.LIST || field.type === FieldType.SELECTION_PLUS || field.type === FieldType.PERSON || field.type === FieldType.ACCOUNT || field.type === FieldType.PERIODS) {
                      <div class="form-check form-switch mb-2 mt-4">
                        <input type="checkbox" class="form-check-input" id="formField{{i}}Presented"
                               name="formField{{i}}Presented" [(ngModel)]="field.presented">
                        <label class="form-check-label" for="formField{{i}}Presented">in Antragsübersichten
                          präsentieren</label>
                      </div>
                    }
                  </div>
                  @if (field.type !== FieldType.HEADER && field.type !== FieldType.SEPARATOR_LINE && field.type !== FieldType.DESCRIPTION && field.type !== FieldType.BLANK_SPACE) {
                    <div class="col-md-12">
                      <div class="form-group mb-2">
                        <label for="formField{{i}}Description" class="data-field-label">optionale Beschreibung</label>
                        <input type="text" class="form-control form-control-sm" id="formField{{i}}Description"
                               name="formField{{i}}Description" [(ngModel)]="field.description">
                      </div>
                    </div>
                  }
                  <div class="col-md-4">
                    <label for="formField{{i}}ConditionalType" class="data-field-label">Bedingungslogik <sup class="text-primary">*</sup></label>
                    <div class="input-group input-group-sm mb-2">
                      <select class="form-select form-select-sm" name="formField{{i}}Type" id="formField{{i}}Type"
                              [(ngModel)]="field.conditionalType" (ngModelChange)="!field.conditionalType ? field.conditionalTerms = [] : undefined">
                        <option [ngValue]="null">Deaktiviert</option>
                        <option [ngValue]="ConditionalType.AND">UND</option>
                        <option [ngValue]="ConditionalType.OR">ODER</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-8">
                    <label for="formField{{i}}ConditionalTerms" class="data-field-label">Bedingungsterme @if (field.conditionalType) {<sup class="text-primary">*</sup>}</label>
                    <rbb-multi-select [(ngModel)]="field.conditionalTerms" prependIcon="fa-solid fa-terminal" [itemTemplate]="stringTemplate" ariaLabel="Bedingungsterme" [valuesFunction]="getAvailableConditionalTermsByDefinition" [valuesFunctionOptions]="{fields: form.fields, index: i}"/>
                    <ng-template #stringTemplate let-value="value">{{value}}</ng-template>
                  </div>
                  @switch (field.type) {
                    @case ('NUMBER') {
                      <div class="col-md-6">
                        <div class="form-group mb-2">
                          <label class="data-field-label" for="formFieldNumber{{i}}Min">Minimaler Wert</label>
                          <input type="number" class="form-control form-control-sm" id="formFieldNumber{{i}}Min"
                                 name="formFieldNumber{{i}}Min" min="1" [(ngModel)]="field.fieldCustomParameter.min">
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group mb-2">
                          <label class="data-field-label" for="formFieldNumber{{i}}Max">Maximaler Wert</label>
                          <input type="number" class="form-control form-control-sm" id="formFieldNumber{{i}}Max"
                                 name="formFieldNumber{{i}}Max" min="1" [(ngModel)]="field.fieldCustomParameter.max">
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-check form-switch mb-3">
                          <input type="checkbox" class="form-check-input" id="formFieldNumber{{i}}Integer"
                                 name="formFieldNumber{{i}}Integer" [(ngModel)]="field.fieldCustomParameter.integer">
                          <label class="form-check-label" for="formFieldNumber{{i}}Integer">Nur Ganzzahlen zulassen</label>
                        </div>
                      </div>
                    }
                    @case ('PERCENT') {
                      <div class="col-12">
                        <div class="form-check form-switch mb-3">
                          <input type="checkbox" class="form-check-input" id="formFieldPercent{{i}}TimeFormat"
                                 name="formFieldPercent{{i}}TimeFormat" [(ngModel)]="field.fieldCustomParameter.timeFormat" (ngModelChange)="percentTimeFormatChanged(field)">
                          <label class="form-check-label" for="formFieldPercent{{i}}TimeFormat">Zeitformat</label>
                        </div>
                      </div>
                      <div class="col-md-6">
                        @if (field.fieldCustomParameter.timeFormat) {
                          <div class="form-group mb-2">
                            <label class="data-field-label" for="formFieldPercent{{i}}AbsoluteHundred">Wert für 100% <sup class="text-primary">*</sup></label>
                            <input type="text" class="form-control form-control-sm" id="formFieldPercent{{i}}AbsoluteHundred" pattern="[0-9]+:([0-5][0-9])"
                                   name="formFieldPercent{{i}}AbsoluteHundred" min="1" [(ngModel)]="field.fieldCustomParameter.absoluteHundred">
                          </div>
                        } @else {
                          <div class="form-group mb-2">
                            <label class="data-field-label" for="formFieldPercent{{i}}AbsoluteHundred">Wert für 100% <sup class="text-primary">*</sup></label>
                            <input type="number" class="form-control form-control-sm" id="formFieldPercent{{i}}AbsoluteHundred"
                                   name="formFieldPercent{{i}}AbsoluteHundred" min="1" [(ngModel)]="field.fieldCustomParameter.absoluteHundred">
                          </div>
                        }
                      </div>
                      <div class="col-md-6">
                        <div class="form-group mb-2">
                          <label class="data-field-label" for="formFieldPercent{{i}}Suffix">Suffix</label>
                          <input type="text" class="form-control form-control-sm" id="formFieldPercent{{i}}Suffix"
                                 name="formFieldPercent{{i}}Suffix" [(ngModel)]="field.fieldCustomParameter.suffix">
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-check form-switch mb-3">
                          <input type="checkbox" class="form-check-input" id="formFieldPercent{{i}}MoreThanHundred"
                                 name="formFieldPercent{{i}}MoreThanHundred" [(ngModel)]="field.fieldCustomParameter.moreThanHundred">
                          <label class="form-check-label" for="formFieldPercent{{i}}MoreThanHundred">Eingabe über 100% möglich</label>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-check form-switch mb-3">
                          <input type="checkbox" class="form-check-input" id="formFieldPercent{{i}}LessThanNull"
                                 name="formFieldPercent{{i}}LessThanNull" [(ngModel)]="field.fieldCustomParameter.lessThanNull" (ngModelChange)="percentLessThanNullChanged(field)">
                          <label class="form-check-label" for="formFieldPercent{{i}}LessThanNull">Eingabe unter 0% möglich</label>
                        </div>
                      </div>
                    }
                    @case ('TEXT') {
                      <div class="col-md-6">
                        <div class="form-group mb-2">
                          <label class="data-field-label" for="formFieldText{{i}}Min">Minimale Zeichenlänge</label>
                          <input type="number" class="form-control form-control-sm" id="formFieldText{{i}}Min"
                                 name="formFieldText{{i}}Min" [(ngModel)]="field.fieldCustomParameter.minLength" min="1">
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group mb-2">
                          <label class="data-field-label" for="formFieldText{{i}}Max">Maximale Zeichenlänge</label>
                          <input type="number" class="form-control form-control-sm" id="formFieldText{{i}}Max"
                                 name="formFieldText{{i}}Max" [(ngModel)]="field.fieldCustomParameter.maxLength" min="5">
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group mb-2">
                          <label class="data-field-label" for="formFieldText{{i}}Rows">Anzahl der Zeilen des Textfeldes <sup
                            class="text-primary">*</sup></label>
                          <input type="number" class="form-control form-control-sm" id="formFieldText{{i}}Rows"
                                 name="formFieldText{{i}}Rows" [(ngModel)]="field.fieldCustomParameter.rows" min="1"
                                 max="15" step="1">
                          @if (error && !field.fieldCustomParameter.rows) {
                            <div class="text-danger small">
                              Dies ist ein Pflichtfeld.
                            </div>
                          }
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-group mb-2">
                          <label class="data-field-label" for="formFieldText{{i}}Regex"><b>(für erfahrene Benutzer)</b>
                            Regulärer Ausdruck</label>
                          <input type="text" class="form-control form-control-sm" id="formFieldText{{i}}Regex"
                                 name="formFieldText{{i}}Regex" [(ngModel)]="field.fieldCustomParameter.regex"
                                 placeholder="z.B. [a-zA-Z0-9]" (ngModelChange)="error = pageError(currentStep)">
                        </div>
                      </div>
                      @if (field.fieldCustomParameter.regex && field.fieldCustomParameter.regex.length) {
                        <div class="col-md-6">
                          <div class="form-group mb-2">
                            <label class="data-field-label" for="formFieldText{{i}}RegexValidValue">Bsp. für gültiger Inhalt
                              <sup class="text-primary">*</sup></label>
                            <input type="text" class="form-control form-control-sm" id="formFieldText{{i}}RegexValidValue"
                                   name="formFieldText{{i}}RegexValidValue"
                                   [(ngModel)]="field.fieldCustomParameter.regexValidValue"
                                   (ngModelChange)="error = pageError(currentStep)">
                            @if (error && !field.fieldCustomParameter.regexValidValue) {
                              <div class="text-danger small">
                                Dies ist ein Pflichtfeld.
                              </div>
                            }
                            @if (error && field.fieldCustomParameter.regexValidValue && !field.fieldCustomParameter.regexValidValue.match(stringToRegex(field.fieldCustomParameter.regex))) {
                              <div class="text-danger small">
                                Dies ist ein ungültiger Inhalt.
                              </div>
                            }
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group mb-2">
                            <label class="data-field-label" for="formFieldText{{i}}RegexInvalidValue">Bsp. für ungültiger
                              Inhalt <sup class="text-primary">*</sup></label>
                            <input type="text" class="form-control form-control-sm" id="formFieldText{{i}}RegexInvalidValue"
                                   name="formFieldText{{i}}RegexInvalidValue"
                                   [(ngModel)]="field.fieldCustomParameter.regexInvalidValue"
                                   (input)="error = pageError(currentStep)">
                            @if (error && !field.fieldCustomParameter.regexInvalidValue) {
                              <div class="text-danger small">
                                Dies ist ein Pflichtfeld.
                              </div>
                            }
                            @if (error && field.fieldCustomParameter.regexInvalidValue && field.fieldCustomParameter.regexInvalidValue.match(stringToRegex(field.fieldCustomParameter.regex))) {
                              <div class="text-danger small">
                                Dies ist ein gültiger Inhalt.
                              </div>
                            }
                          </div>
                        </div>
                        <div class="col-12">
                          <div class="form-group mb-2">
                            <label class="data-field-label" for="formFieldText{{i}}RegexErrorMessage">Fehlermeldung, wenn
                              die Bedingungen nicht erfüllt sind. <sup class="text-primary">*</sup></label>
                            <input type="text" class="form-control form-control-sm" id="formFieldText{{i}}RegexErrorMessage"
                                   name="formFieldText{{i}}RegexErrorMessage"
                                   [(ngModel)]="field.fieldCustomParameter.regexErrorMessage">
                            @if (error && !field.fieldCustomParameter.regexErrorMessage) {
                              <div class="text-danger small">
                                Dies ist ein Pflichtfeld.
                              </div>
                            }
                          </div>
                        </div>
                      }
                    }
                    @case ('YES_NO') {
                      <div class="col-md-6">
                        <div class="form-group mb-2">
                          <label class="data-field-label" for="formFieldYesNo{{i}}YesLabel">Label, wenn ausgewählt</label>
                          <input type="text" class="form-control form-control-sm" id="formFieldYesNo{{i}}YesLabel"
                                 name="formFieldYesNo{{i}}YesLabel" [(ngModel)]="field.fieldCustomParameter.yesLabel">
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group mb-2">
                          <label class="data-field-label" for="formFieldYesNo{{i}}NoLabel">Label, wenn nicht
                            ausgewählt</label>
                          <input type="text" class="form-control form-control-sm" id="formFieldYesNo{{i}}NoLabel"
                                 name="formFieldYesNo{{i}}NoLabel" [(ngModel)]="field.fieldCustomParameter.noLabel">
                        </div>
                      </div>
                    }
                    @case ('MOBILE_WORK_AGREEMENT') {
                      <div class="col-12">
                        <div class="form-check form-switch mb-3">
                          <input type="checkbox" class="form-check-input" id="formFieldMobileWorkAgreement{{i}}Required"
                                 name="formFieldMobileWorkAgreement{{i}}Required"
                                 [(ngModel)]="field.fieldCustomParameter.required">
                          <label class="form-check-label" for="formFieldMobileWorkAgreement{{i}}Required">Aktuell gültige Vereinbarung muss vorhanden sein.</label>
                        </div>
                      </div>
                    }
                    @case ('COST_CENTRE') {
                      <div class="col-12">
                        <div class="form-check form-switch mb-3">
                          <input type="checkbox" class="form-check-input" id="formFieldCostCentre{{i}}ForceSelection"
                                 name="formFieldCostCentre{{i}}ForceSelection"
                                 [(ngModel)]="field.fieldCustomParameter.forceSelection"
                                 (ngModelChange)="costCentreForceSelectionChanged(field)">
                          <label class="form-check-label" for="formFieldCostCentre{{i}}ForceSelection">Auswahl
                            erzwingen</label>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-check form-switch mb-3">
                          <input type="checkbox" class="form-check-input" id="formFieldCostCentre{{i}}MyCostCentre"
                                 name="formFieldCostCentre{{i}}MyCostCentre"
                                 [(ngModel)]="field.fieldCustomParameter.myCostCentre">
                          <label class="form-check-label" for="formFieldCostCentre{{i}}MyCostCentre">Eigene KST
                            vorausgewählt</label>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-check form-switch mb-3">
                          <input type="checkbox" class="form-check-input" id="formFieldCostCentre{{i}}ForApproval"
                                 name="formFieldCostCentre{{i}}ForApproval"
                                 [(ngModel)]="field.fieldCustomParameter.forApproval"
                                 (change)="costCentreForApprovalChanged(field)">
                          <label class="form-check-label" for="formFieldCostCentre{{i}}ForApproval">KST für Genehmigungsweg
                            nutzen</label>
                        </div>
                      </div>
                    }
                    @case ('DATE') {
                      <div class="col-md-6">
                        <div class="form-check form-switch mb-3">
                          <input type="checkbox" class="form-check-input" id="formFieldPeriod{{i}}Future"
                                 name="formFieldPeriod{{i}}Future" [(ngModel)]="field.fieldCustomParameter.future">
                          <label class="form-check-label" for="formFieldPeriod{{i}}Future">Datum muss in der Zukunft liegen</label>
                        </div>
                      </div>
                    }
                    @case ('PERIOD') {
                      <div class="col-md-6">
                        <div class="form-check form-switch mb-3">
                          <input type="checkbox" class="form-check-input" id="formFieldPeriod{{i}}Unlimited"
                                 name="formFieldPeriod{{i}}Unlimited" [(ngModel)]="field.fieldCustomParameter.unlimited">
                          <label class="form-check-label" for="formFieldPeriod{{i}}Unlimited">Auswahl "unbefristet" möglich</label>
                        </div>
                      </div>
                    }
                    @case ('LIST') {
                      <div class="col-md-6">
                        <div class="form-group mb-2">
                          <label class="data-field-label" for="formFieldList{{i}}Min">Mindestanzahl</label>
                          <input type="number" class="form-control form-control-sm" id="formFieldList{{i}}Min"
                                 name="formFieldList{{i}}Min" min="1" [(ngModel)]="field.fieldCustomParameter.min">
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group mb-2">
                          <label class="data-field-label" for="formFieldList{{i}}Max">Maximalanzahl</label>
                          <input type="number" class="form-control form-control-sm" id="formFieldList{{i}}Max"
                                 name="formFieldList{{i}}Max" min="1" [(ngModel)]="field.fieldCustomParameter.max">
                        </div>
                      </div>
                      <div class="col-12">
                        <span class="small text-secondary d-block mb-3 description-badge"><i class="fas fa-info"></i>&ensp;Min und Max nur ausfüllen, wenn es wirklich benötigt wird.</span>
                      </div>
                      <div class="col-12">
                        <div class="form-check form-switch mb-3">
                          <input type="checkbox" class="form-check-input" id="formFieldList{{i}}Duplicates"
                                 name="formFieldList{{i}}Duplicates" [(ngModel)]="field.fieldCustomParameter.duplicates">
                          <label class="form-check-label" for="formFieldList{{i}}Duplicates">Duplikate zulassen</label>
                        </div>
                      </div>
                    }
                    @case ('PERIODS') {
                      <div class="col-md-6">
                        <div class="form-group mb-2">
                          <label class="data-field-label" for="formFieldList{{i}}Min">Mindestanzahl</label>
                          <input type="number" class="form-control form-control-sm" id="formFieldList{{i}}Min"
                                 name="formFieldList{{i}}Min" min="1" [(ngModel)]="field.fieldCustomParameter.min">
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group mb-2">
                          <label class="data-field-label" for="formFieldList{{i}}Max">Maximalanzahl</label>
                          <input type="number" class="form-control form-control-sm" id="formFieldList{{i}}Max"
                                 name="formFieldList{{i}}Max" min="1" [(ngModel)]="field.fieldCustomParameter.max">
                        </div>
                      </div>
                      <div class="col-12">
                        <span class="small text-secondary d-block mb-3 description-badge"><i class="fas fa-info"></i>&ensp;Min und Max nur ausfüllen, wenn es wirklich benötigt wird.</span>
                      </div>
                      <div class="col-12">
                        <div class="form-check form-switch mb-3">
                          <input type="checkbox" class="form-check-input" id="formFieldList{{i}}sameMonth"
                                 name="formFieldList{{i}}sameMonth" [(ngModel)]="field.fieldCustomParameter.sameMonth">
                          <label class="form-check-label" for="formFieldList{{i}}sameMonth">Startdaten müssen im selben Monat liegen</label>
                        </div>
                      </div>
                    }
                    @case ('ROOM') {
                      <div class="col-12">
                        <div class="form-check form-switch mb-3">
                          <input type="checkbox" class="form-check-input" id="formFieldRoom{{i}}ForceSelection"
                                 name="formFieldRoom{{i}}ForceSelection"
                                 [(ngModel)]="field.fieldCustomParameter.forceSelection">
                          <label class="form-check-label" for="formFieldRoom{{i}}ForceSelection">Auswahl erzwingen</label>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-check form-switch mb-3">
                          <input type="checkbox" class="form-check-input" id="formFieldRoom{{i}}MyRoom"
                                 name="formFieldRoom{{i}}MyRoom" [(ngModel)]="field.fieldCustomParameter.myRoom">
                          <label class="form-check-label" for="formFieldRoom{{i}}MyRoom">Eigenen Raum vorauswählen</label>
                        </div>
                      </div>
                    }
                    @case ('SELECTION') {
                      <div class="col-md-6">
                        <div class="form-group mb-2">
                          <label class="data-field-label" for="formFieldSelection{{i}}MinSelection">Mindestanzahl der
                            Auswahl</label>
                          <input type="number" class="form-control form-control-sm" id="formFieldSelection{{i}}MinSelection"
                                 name="formFieldSelection{{i}}MinSelection" min="1"
                                 [(ngModel)]="field.fieldCustomParameter.minSelection">
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group mb-2">
                          <label class="data-field-label" for="formFieldSelection{{i}}MaxSelection">Maximalanzahl der
                            Auswahl</label>
                          <input type="number" class="form-control form-control-sm" id="formFieldSelection{{i}}MaxSelection"
                                 name="formFieldSelection{{i}}MaxSelection" min="1"
                                 [(ngModel)]="field.fieldCustomParameter.maxSelection">
                        </div>
                      </div>
                      <div class="col-12">
                        <span class="small text-secondary d-block mb-3 description-badge"><i class="fas fa-info"></i>&ensp;Min und Max nur ausfüllen, wenn es wirklich benötigt wird.</span>
                      </div>
                      <div class="col-12">
                        <div class="form-check form-switch mb-3">
                          <input type="checkbox" class="form-check-input" id="formFieldSelection{{i}}Other"
                                 name="formFieldSelection{{i}}Other" [(ngModel)]="field.fieldCustomParameter.other">
                          <label class="form-check-label" for="formFieldSelection{{i}}Other">Sonstiges Feld
                            hinzufügen</label>
                        </div>
                        <span class="small text-secondary d-block mb-3 description-badge"><i class="fas fa-info"></i>&ensp;Fügt ein optionales Freitext-Feld am Ende der Auswahl hinzu.</span>
                      </div>
                      <div class="col-12">
                        <div class="form-group mb-2">
                          <label class="data-field-label">Daten <sup class="text-primary">*</sup></label>
                          @for (h of field.fieldCustomParameter.items; let j = $index; track j) {
                            <div class="row" [attr.data-object]="h">
                              <div class="col">
                                <input type="text" id="formFieldSelection{{i}}items{{j}}"
                                       name="formFieldSelection{{i}}items{{j}}" class="form-control form-control-sm"
                                       [(ngModel)]="field.fieldCustomParameter.items[j]"
                                       [attr.aria-label]="'Auswahlmöglichkeit ' + (j + 1)"

                                       placeholder="Auswahlmöglichkeit {{j + 1}}">
                              </div>
                              <div class="col-auto fas-arrow-width">
                                @if (j) {
                                  <i class="d-inline-block far fa-caret-square-up align-middle pointer transform grow-effect"
                                     (click)="orderDataItem(field, j, j - 1)"
                                     (keydown.space)="orderDataItem(field, j, j - 1)"
                                     (keydown.enter)="orderDataItem(field, j, j - 1)"
                                     tabindex="0"></i>
                                }
                              </div>
                              <div class="col-auto fas-arrow-width">
                                @if (j < field.fieldCustomParameter.items.length - 1) {
                                  <i class="d-inline-block far fa-caret-square-down align-middle pointer transform grow-effect"
                                     (click)="orderDataItem(field, j, j + 1)"
                                     (keydown.space)="orderDataItem(field, j, j + 1)"
                                     (keydown.enter)="orderDataItem(field, j, j + 1)"
                                     tabindex="0"></i>
                                }
                              </div>
                              <div class="col-auto">
                                <i class="d-inline-block fas fa-times text-danger pointer align-middle transform grow-effect"
                                   (click)="removeSpecificCustomFieldItem(field, j)"
                                   (keydown.space)="removeSpecificCustomFieldItem(field, j)"
                                   (keydown.enter)="removeSpecificCustomFieldItem(field, j)"
                                   tabindex="0"></i>
                              </div>
                            </div>
                          }
                          @if (error && isListEmpty(field.fieldCustomParameter.items)) {
                            <div class="row text-danger small">
                              Dies ist ein Pflichtfeld.
                            </div>
                          }
                        </div>
                        <div class="row">
                          <div class="col">
                            <hr class="m-0 p-0 hr-custom">
                          </div>
                          <div class="col-auto">
                            <button type="button" class="btn btn-sm btn-outline-success me-2"
                                    (click)="addCustomFieldItem(field)" aria-label="Auswahlmöglichkeit hinzufügen">
                              <i class="fas fa-plus" aria-hidden="true"></i></button>
                            <button type="button" class="btn btn-sm btn-outline-danger"
                                    (click)="removeCustomFieldItem(field)"
                                    aria-label="Auswahlmöglichkeit entfernen"><i class="fas fa-minus"
                                                                                 aria-hidden="true"></i></button>
                          </div>
                          <div class="col">
                            <hr class="m-0 p-0 hr-custom">
                          </div>
                        </div>
                      </div>
                    }
                    @case ('SELECTION_PLUS') {
                      <div class="col-md-6">
                        <div class="form-group mb-2">
                          <label class="data-field-label" for="formFieldSelection{{i}}MinSelection">Mindestanzahl der
                            Auswahl</label>
                          <input type="number" class="form-control form-control-sm"
                                 id="formFieldSelectionPlus{{i}}MinSelection" name="formFieldSelectionPlus{{i}}MinSelection"
                                 min="1" [(ngModel)]="field.fieldCustomParameter.minSelection">
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group mb-2">
                          <label class="data-field-label" for="formFieldSelection{{i}}MaxSelection">Maximalanzahl der
                            Auswahl</label>
                          <input type="number" class="form-control form-control-sm"
                                 id="formFieldSelectionPlus{{i}}MaxSelection" name="formFieldSelectionPlus{{i}}MaxSelection"
                                 min="1" [(ngModel)]="field.fieldCustomParameter.maxSelection">
                        </div>
                      </div>
                      <div class="col-12">
                        <span class="small text-secondary d-block mb-3 description-badge"><i class="fas fa-info"></i>&ensp;Min und Max nur ausfüllen, wenn es wirklich benötigt wird.</span>
                      </div>
                      <div class="col-6">
                        <div class="form-check form-switch mb-3">
                          <input type="checkbox" class="form-check-input"
                                 id="formFieldSelectionPlus{{i}}ForceAdditionalField"
                                 name="formFieldSelectionPlus{{i}}ForceAdditionalField"
                                 [(ngModel)]="field.fieldCustomParameter.forceAdditionalField">
                          <label class="form-check-label" for="formFieldSelectionPlus{{i}}ForceAdditionalField">Ausgewählte
                            Felder müssen befüllt werden.</label>
                        </div>
                        <div class="form-check form-switch mb-3">
                          <input type="checkbox" class="form-check-input" id="formFieldSelectionPlus{{i}}Sum"
                                 name="formFieldSelectionPlus{{i}}Sum" [(ngModel)]="field.fieldCustomParameter.sum">
                          <label class="form-check-label" for="formFieldSelectionPlus{{i}}Sum">Automatische Summierung von
                            Zahlen oder Zeiten</label>
                        </div>
                      </div>
                      <div class="col-6">
                        <div class="form-group mb-2">
                          <label for="formFieldSelectionPlus{{i}}Suffix" class="data-field-label">Suffix</label>
                          <input type="text" class="form-control form-control-sm"
                                 [(ngModel)]="field.fieldCustomParameter.suffix" id="formFieldSelectionPlus{{i}}Suffix"
                                 name="formFieldSelectionPlus{{i}}Suffix">
                          <span class="small text-secondary d-block mb-3 description-badge"><i class="fas fa-info"></i>&ensp;Wird am Ende aller Eingaben angehangen.</span>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-group mb-2">
                          <label class="data-field-label">Daten <sup class="text-primary">*</sup></label>
                          @for (h of field.fieldCustomParameter.items; let j = $index; track j) {
                            <div class="row">
                              <div class="col">
                                <input type="text" id="formFieldSelectionPlus{{i}}items{{j}}"
                                       name="formFieldSelectionPlus{{i}}items{{j}}" class="form-control form-control-sm"
                                       [(ngModel)]="field.fieldCustomParameter.items[j]"
                                       [attr.aria-label]="'Auswahlmöglichkeit ' + (j + 1)"
                                       placeholder="Auswahlmöglichkeit {{j + 1}}"
                                >
                              </div>
                              <div class="col-auto fas-arrow-width">
                                @if (j) {
                                  <i class="d-inline-block far fa-caret-square-up align-middle pointer transform grow-effect"
                                     (click)="orderDataItem(field, j, j - 1)"
                                     (keydown.space)="orderDataItem(field, j, j - 1)"
                                     (keydown.enter)="orderDataItem(field, j, j - 1)"
                                     tabindex="0"></i>
                                }
                              </div>
                              <div class="col-auto fas-arrow-width">
                                @if (j < field.fieldCustomParameter.items.length - 1) {
                                  <i class="d-inline-block far fa-caret-square-down align-middle pointer transform grow-effect"
                                     (click)="orderDataItem(field, j, j + 1)"
                                     (keydown.space)="orderDataItem(field, j, j + 1)"
                                     (keydown.enter)="orderDataItem(field, j, j + 1)"
                                     tabindex="0"></i>
                                }
                              </div>
                              <div class="col-auto">
                                <i class="d-inline-block fas fa-times text-danger pointer align-middle transform grow-effect"
                                   (click)="removeSpecificCustomFieldItem(field, j)"
                                   (keydown.space)="removeSpecificCustomFieldItem(field, j)"
                                   (keydown.enter)="removeSpecificCustomFieldItem(field, j)"
                                   tabindex="0"></i>
                              </div>
                            </div>
                          }
                          @if (error && isListEmpty(field.fieldCustomParameter.items)) {
                            <div class="text-danger small">
                              Dies ist ein Pflichtfeld.
                            </div>
                          }
                        </div>
                        <div class="row">
                          <div class="col">
                            <hr class="m-0 p-0 hr-custom">
                          </div>
                          <div class="col-auto">
                            <button type="button" class="btn btn-sm btn-outline-success me-2"
                                    (click)="addCustomFieldItem(field)" aria-label="Auswahlmöglichkeit hinzufügen">
                              <i class="fas fa-plus" aria-hidden="true"></i></button>
                            <button type="button" class="btn btn-sm btn-outline-danger"
                                    (click)="removeCustomFieldItem(field)"
                                    aria-label="Auswahlmöglichkeit entfernen"><i class="fas fa-minus"
                                                                                 aria-hidden="true"></i></button>
                          </div>
                          <div class="col">
                            <hr class="m-0 p-0 hr-custom">
                          </div>
                        </div>
                      </div>
                    }
                    @case ('TABLE') {
                      <div class="col-md-6">
                        <div class="form-group mb-2">
                          <label class="data-field-label" for="formFieldTable{{i}}Min">Mindestanzahl</label>
                          <input type="number" class="form-control form-control-sm" id="formFieldTable{{i}}Min"
                                 name="formFieldTable{{i}}Min" min="1" [(ngModel)]="field.fieldCustomParameter.min">
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group mb-2">
                          <label class="data-field-label" for="formFieldTable{{i}}Max">Maximalanzahl</label>
                          <input type="number" class="form-control form-control-sm" id="formFieldTable{{i}}Max"
                                 name="formFieldTable{{i}}Max" min="1" [(ngModel)]="field.fieldCustomParameter.max">
                        </div>
                      </div>
                      <div class="col-12">
                        <span class="small text-secondary d-block mb-3 description-badge"><i class="fas fa-info"></i>&ensp;Min und Max nur ausfüllen, wenn es wirklich benötigt wird.</span>
                      </div>
                      <div class="col-12">
                        <div class="form-check form-switch mb-3">
                          <input type="checkbox" class="form-check-input" id="formFieldTable{{i}}Sum"
                                 name="formFieldTable{{i}}Sum" [(ngModel)]="field.fieldCustomParameter.sum">
                          <label class="form-check-label" for="formFieldTable{{i}}Sum">Automatische Summenreihe am Ende der
                            Tabelle</label>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-group mb-2">
                          <label class="data-field-label">Spalten <sup class="text-primary">*</sup></label>
                          @for (header of field.fieldCustomParameter.head; let j = $index; track j) {
                            <div class="row">
                              <div class="col">
                                <input type="text" id="formField{{i}}header{{j}}" name="formField{{i}}header{{j}}"
                                       class="form-control form-control-sm" [(ngModel)]="field.fieldCustomParameter.head[j]"
                                       placeholder="Spaltenkopf #{{j + 1}}" [attr.aria-label]="'Spaltenkopf ' + (j + 1)">
                              </div>
                              <div class="col-auto fas-arrow-width">
                                @if (j) {
                                  <i class="d-inline-block far fa-caret-square-up align-middle pointer transform grow-effect"
                                     (click)="orderDataHead(field, j, j - 1)"
                                     (keydown.space)="orderDataHead(field, j, j - 1)"
                                     (keydown.enter)="orderDataHead(field, j, j - 1)"
                                     tabindex="0"></i>
                                }
                              </div>
                              <div class="col-auto fas-arrow-width">
                                @if (j < field.fieldCustomParameter.head.length - 1) {
                                  <i class="d-inline-block far fa-caret-square-down align-middle pointer transform grow-effect"
                                     (click)="orderDataHead(field, j, j + 1)"
                                     (keydown.space)="orderDataHead(field, j, j + 1)"
                                     (keydown.enter)="orderDataHead(field, j, j + 1)"
                                     tabindex="0"></i>
                                }
                              </div>
                              <div class="col-auto">
                                <i class="d-inline-block fas fa-times text-danger pointer align-middle transform grow-effect"
                                   (click)="removeSpecificCustomFieldHeadItem(field, j)"
                                   (keydown.space)="removeSpecificCustomFieldHeadItem(field, j)"
                                   (keydown.enter)="removeSpecificCustomFieldHeadItem(field, j)"
                                   tabindex="0"></i>
                              </div>
                            </div>
                          }
                          @if (error && isListEmpty(field.fieldCustomParameter.head)) {
                            <div class="text-danger small">
                              Dies ist ein Pflichtfeld.
                            </div>
                          }
                        </div>
                        <div class="row">
                          <div class="col">
                            <hr class="m-0 p-0 hr-custom">
                          </div>
                          <div class="col-auto">
                            <button type="button" class="btn btn-sm btn-outline-success me-2"
                                    (click)="addCustomFieldHeadItem(field)" aria-label="Spalte hinzufügen"><i
                              class="fas fa-plus" aria-hidden="true"></i></button>
                            <button type="button" class="btn btn-sm btn-outline-danger"
                                    (click)="removeCustomFieldHeadItem(field)" aria-label="Spalte entfernen"><i
                              class="fas fa-minus" aria-hidden="true"></i></button>
                          </div>
                          <div class="col">
                            <hr class="m-0 p-0 hr-custom">
                          </div>
                        </div>
                      </div>
                    }
                    @case ('SELECTION_TABLE') {
                      <div class="col-12">
                        <div class="form-check form-switch mb-3">
                          <input type="checkbox" class="form-check-input" id="formFieldTable{{i}}MultipleOptionsPerItem"
                                 name="formFieldTable{{i}}MultipleOptionsPerItem" [(ngModel)]="field.fieldCustomParameter.multipleOptionsPerItem">
                          <label class="form-check-label" for="formFieldTable{{i}}MultipleOptionsPerItem">Mehrere Option pro Eintrag auswählbar</label>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-group mb-2">
                          <label class="data-field-label">Spalten <sup class="text-primary">*</sup></label>
                          @for (option of field.fieldCustomParameter.options; let j = $index; track j) {
                            <div class="row">
                              <div class="col">
                                <input type="text" id="formField{{i}}option{{j}}" name="formField{{i}}option{{j}}"
                                       class="form-control form-control-sm" [(ngModel)]="field.fieldCustomParameter.options[j]"
                                       placeholder="Option #{{j + 1}}" [attr.aria-label]="'Option ' + (j + 1)">
                              </div>
                              <div class="col-auto fas-arrow-width">
                                @if (j) {
                                  <i class="d-inline-block far fa-caret-square-up align-middle pointer transform grow-effect"
                                     (click)="orderDataOption(field, j, j - 1)"
                                     (keydown.space)="orderDataOption(field, j, j - 1)"
                                     (keydown.enter)="orderDataOption(field, j, j - 1)"
                                     tabindex="0"></i>
                                }
                              </div>
                              <div class="col-auto fas-arrow-width">
                                @if (j < field.fieldCustomParameter.options.length - 1) {
                                  <i class="d-inline-block far fa-caret-square-down align-middle pointer transform grow-effect"
                                     (click)="orderDataOption(field, j, j + 1)"
                                     (keydown.space)="orderDataOption(field, j, j + 1)"
                                     (keydown.enter)="orderDataOption(field, j, j + 1)"
                                     tabindex="0"></i>
                                }
                              </div>
                              <div class="col-auto">
                                <i class="d-inline-block fas fa-times text-danger pointer align-middle transform grow-effect"
                                   (click)="removeSpecificCustomFieldOption(field, j)"
                                   (keydown.space)="removeSpecificCustomFieldOption(field, j)"
                                   (keydown.enter)="removeSpecificCustomFieldOption(field, j)"
                                   tabindex="0"></i>
                              </div>
                            </div>
                          }
                          @if (error && isListEmpty(field.fieldCustomParameter.options)) {
                            <div class="text-danger small">
                              Dies ist ein Pflichtfeld.
                            </div>
                          }
                        </div>
                        <div class="row">
                          <div class="col">
                            <hr class="m-0 p-0 hr-custom">
                          </div>
                          <div class="col-auto">
                            <button type="button" class="btn btn-sm btn-outline-success me-2"
                                    (click)="addCustomFieldOption(field)" aria-label="Option hinzufügen"><i
                              class="fas fa-plus" aria-hidden="true"></i></button>
                            <button type="button" class="btn btn-sm btn-outline-danger"
                                    (click)="removeCustomFieldOption(field)" aria-label="Option entfernen"><i
                              class="fas fa-minus" aria-hidden="true"></i></button>
                          </div>
                          <div class="col">
                            <hr class="m-0 p-0 hr-custom">
                          </div>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-group mb-2">
                          <label class="data-field-label">Einträge <sup class="text-primary">*</sup></label>
                          @for (option of field.fieldCustomParameter.items; let j = $index; track j) {
                            <div class="row">
                              <div class="col">
                                <textarea id="formField{{i}}item{{j}}" name="formField{{i}}item{{j}}" [rows]="3"
                                          class="form-control form-control-sm" [(ngModel)]="field.fieldCustomParameter.items[j]"
                                          placeholder="Eintrag #{{j + 1}}" [attr.aria-label]="'Eintrag ' + (j + 1)"></textarea>
                              </div>
                              <div class="col-auto fas-arrow-width">
                                @if (j) {
                                  <i class="d-inline-block far fa-caret-square-up align-middle pointer transform grow-effect"
                                     (click)="orderDataItem(field, j, j - 1)"
                                     (keydown.space)="orderDataItem(field, j, j - 1)"
                                     (keydown.enter)="orderDataItem(field, j, j - 1)"
                                     tabindex="0"></i>
                                }
                              </div>
                              <div class="col-auto fas-arrow-width">
                                @if (j < field.fieldCustomParameter.options.length - 1) {
                                  <i class="d-inline-block far fa-caret-square-down align-middle pointer transform grow-effect"
                                     (click)="orderDataItem(field, j, j + 1)"
                                     (keydown.space)="orderDataItem(field, j, j + 1)"
                                     (keydown.enter)="orderDataItem(field, j, j + 1)"
                                     tabindex="0"></i>
                                }
                              </div>
                              <div class="col-auto">
                                <i class="d-inline-block fas fa-times text-danger pointer align-middle transform grow-effect"
                                   (click)="removeSpecificCustomFieldItem(field, j)"
                                   (keydown.space)="removeSpecificCustomFieldItem(field, j)"
                                   (keydown.enter)="removeSpecificCustomFieldItem(field, j)"
                                   tabindex="0"></i>
                              </div>
                            </div>
                          }
                          @if (error && isListEmpty(field.fieldCustomParameter.options)) {
                            <div class="text-danger small">
                              Dies ist ein Pflichtfeld.
                            </div>
                          }
                        </div>
                        <div class="row">
                          <div class="col">
                            <hr class="m-0 p-0 hr-custom">
                          </div>
                          <div class="col-auto">
                            <button type="button" class="btn btn-sm btn-outline-success me-2"
                                    (click)="addCustomFieldItem(field)" aria-label="Eintrag hinzufügen"><i
                              class="fas fa-plus" aria-hidden="true"></i></button>
                            <button type="button" class="btn btn-sm btn-outline-danger"
                                    (click)="removeCustomFieldItem(field)" aria-label="Eintrag entfernen"><i
                              class="fas fa-minus" aria-hidden="true"></i></button>
                          </div>
                          <div class="col">
                            <hr class="m-0 p-0 hr-custom">
                          </div>
                        </div>
                      </div>
                    }
                    @case ('FILE') {
                      <div class="col-md-6">
                        <div class="form-group mb-2">
                          <label class="data-field-label" for="formFieldFile{{i}}Min">Mindestanzahl</label>
                          <input type="number" class="form-control form-control-sm" id="formFieldFile{{i}}Min"
                                 name="formFieldFile{{i}}Min" min="1" [(ngModel)]="field.fieldCustomParameter.min">
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group mb-2">
                          <label class="data-field-label" for="formFieldFile{{i}}Max">Maximalanzahl</label>
                          <input type="number" class="form-control form-control-sm" id="formFieldFile{{i}}Max"
                                 name="formFieldFile{{i}}Max" min="1" [(ngModel)]="field.fieldCustomParameter.max">
                        </div>
                      </div>
                      <div class="col-12">
                        <span class="small text-secondary d-block mb-3 description-badge"><i class="fas fa-info"></i>&ensp;Min und Max nur ausfüllen, wenn es wirklich benötigt wird.</span>
                      </div>
                      <div class="col-12">
                        <div class="form-group mb-2">
                          <label class="data-field-label">Erlaubte Dateitypen <sup class="text-primary">*</sup></label>
                          <div class="row">
                            <div class="col-12">
                              <div class="form-check">
                                <input type="checkbox" class="form-check-input" id="formFieldFile{{i}}FileTypesJpeg"
                                       name="formFieldFile{{i}}FileTypesJpeg"
                                       (change)="changeFileType(field, 'image/jpeg', $event)"
                                       [checked]="fileTypeSelected(field, 'image/jpeg')">
                                <label class="form-check-label" for="formFieldFile{{i}}FileTypesJpeg">JPEG Bilder (.jpeg,
                                  .jpg, .jpe)</label>
                              </div>
                              <div class="form-check">
                                <input type="checkbox" class="form-check-input" id="formFieldFile{{i}}FileTypesPng"
                                       name="formFieldFile{{i}}FileTypesPng"
                                       (change)="changeFileType(field, 'image/png', $event)"
                                       [checked]="fileTypeSelected(field, 'image/png')">
                                <label class="form-check-label" for="formFieldFile{{i}}FileTypesPng">PNG Bilder
                                  (.png)</label>
                              </div>
                              <div class="form-check">
                                <input type="checkbox" class="form-check-input" id="formFieldFile{{i}}FileTypesPdf"
                                       name="formFieldFile{{i}}FileTypesPdf"
                                       (change)="changeFileType(field, 'application/pdf', $event)"
                                       [checked]="fileTypeSelected(field, 'application/pdf')">
                                <label class="form-check-label" for="formFieldFile{{i}}FileTypesPdf">PDF Dokument
                                  (.pdf)</label>
                              </div>
                              <div class="form-check">
                                <input type="checkbox" class="form-check-input" id="formFieldFile{{i}}FileTypesWord"
                                       name="formFieldFile{{i}}FileTypesWord"
                                       (change)="changeFileType(field, 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', $event)"
                                       [checked]="fileTypeSelected(field, 'application/vnd.openxmlformats-officedocument.wordprocessingml.document')">
                                <label class="form-check-label" for="formFieldFile{{i}}FileTypesWord">Word Dokument
                                  (.docx)</label>
                              </div>
                              <div class="form-check">
                                <input type="checkbox" class="form-check-input" id="formFieldFile{{i}}FileTypesExcel"
                                       name="formFieldFile{{i}}FileTypesExcel"
                                       (change)="changeFileType(field, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', $event)"
                                       [checked]="fileTypeSelected(field, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')">
                                <label class="form-check-label" for="formFieldFile{{i}}FileTypesExcel">Excel Tabelle
                                  (.xlsx)</label>
                              </div>
                              <div class="form-check">
                                <input type="checkbox" class="form-check-input" id="formFieldFile{{i}}FileTypesAutoCAD"
                                       name="formFieldFile{{i}}FileTypesAutoCAD"
                                       (change)="changeFileType(field, 'application/acad', $event)"
                                       [checked]="fileTypeSelected(field, 'application/acad')">
                                <label class="form-check-label" for="formFieldFile{{i}}FileTypesAutoCAD">AutoCAD Dateien
                                  (.dwg)</label>
                              </div>
                              <div class="form-check">
                                <input type="checkbox" class="form-check-input" id="formFieldFile{{i}}FileTypesAutoVisio"
                                       name="formFieldFile{{i}}FileTypesAutoVisio"
                                       (change)="changeFileType(field, 'application/vnd.visio', $event)"
                                       [checked]="fileTypeSelected(field, 'application/vnd.visio')">
                                <label class="form-check-label" for="formFieldFile{{i}}FileTypesAutoVisio">Visio Dateien bis
                                  2010 (.vsd)</label>
                              </div>
                              <div class="form-check">
                                <input type="checkbox" class="form-check-input"
                                       id="formFieldFile{{i}}FileTypesAutoVisio2013"
                                       name="formFieldFile{{i}}FileTypesAutoVisio2013"
                                       (change)="changeFileType(field, 'application/vnd.visio2013', $event)"
                                       [checked]="fileTypeSelected(field, 'application/vnd.visio2013')">
                                <label class="form-check-label" for="formFieldFile{{i}}FileTypesAutoVisio2013">Visio Dateien
                                  ab 2013 (.vsdx)</label>
                              </div>
                            </div>
                            @if (error && isListEmpty(field.fieldCustomParameter.fileTypes)) {
                              <div class="text-danger small">
                                Dies ist ein Pflichtfeld.
                              </div>
                            }
                          </div>
                        </div>
                      </div>
                    }
                    @case ('DESCRIPTION') {
                      <div class="col-12">
                      <span class="small text-secondary d-block mb-3 description-badge">
                        <i class="fas fa-info"></i>&ensp;Sie können Systemzeichen benutzen, um die Schrift zu formatieren z.B. **Überschrift**<br/>
                        ** - <span class="fw-bold">fett</span><br/>## - <span class="fst-italic">kursiv</span><br/>
                        _ _ - <span class="text-decoration-underline">unterstrichen</span><br/>
                        &#64;rot&#64; - <span class="text-primary">rot</span><br/>
                        ^^ - <span class="small">klein</span>
                      </span>
                        <div class="form-group mb-2">
                          <label class="data-field-label" for="formFieldDescription{{i}}Value">Text <sup
                            class="text-primary">*</sup></label>
                          <textarea class="form-control form-control-sm" id="formFieldDescription{{i}}Value"
                                    name="formFieldDescription{{i}}Value" rows="7"
                                    [(ngModel)]="field.fieldCustomParameter.value"></textarea>
                        </div>
                      </div>
                    }
                    @case ('PERSON') {
                      <div class="col-12">
                        <div class="form-check form-switch mb-3">
                          <input type="checkbox" class="form-check-input" id="formFieldPerson{{i}}ForApproval"
                                 name="formFieldPerson{{i}}ForApproval"
                                 [(ngModel)]="field.fieldCustomParameter.forApproval"
                                 (change)="personForApprovalChanged(field)">
                          <label class="form-check-label" for="formFieldPerson{{i}}ForApproval">Für Genehmigungsweg
                            nutzen</label>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group mb-2">
                          <label class="data-field-label">Rundfunkanstalt / GSEA</label>
                          <div class="form-check form-switch">
                            <input type="checkbox" class="form-check-input" id="formFieldPerson{{i}}rbb"
                                   (change)="changeActiveDirectories(field, 'RBB')"
                                   [checked]="field.fieldCustomParameter.activeDirectories?.includes('RBB')"
                                   name="formFieldPerson{{i}}rbb">
                            <label class="form-check-label" for="formFieldPerson{{i}}rbb">rbb (inkl. POC, Text, GS)</label>
                          </div>
                          <div class="form-check form-switch">
                            <input type="checkbox" class="form-check-input" id="formFieldPerson{{i}}hsb"
                                   (change)="changeActiveDirectories(field, 'HSB')"
                                   [checked]="field.fieldCustomParameter.activeDirectories?.includes('HSB')"
                                   name="formFieldPerson{{i}}hsb">
                            <label class="form-check-label" for="formFieldPerson{{i}}hsb">HSB</label>
                          </div>
                          <div class="form-check form-switch">
                            <input type="checkbox" class="form-check-input" id="formFieldPerson{{i}}ivz"
                                   (change)="changeActiveDirectories(field, 'IVZ')"
                                   [checked]="field.fieldCustomParameter.activeDirectories?.includes('IVZ')"
                                   name="formFieldPerson{{i}}ivz">
                            <label class="form-check-label" for="formFieldPerson{{i}}ivz">IVZ</label>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group mb-2">
                          <label class="data-field-label">Vertragstyp</label>
                          <div class="form-check form-switch">
                            <input type="checkbox" class="form-check-input" id="formFieldPerson{{i}}Permanent"
                                   (change)="changeEmployeeTypes(field, 'PERMANENT')"
                                   [checked]="field.fieldCustomParameter.employeeTypes?.includes('PERMANENT')"
                                   name="formFieldPerson{{i}}Permanent">
                            <label class="form-check-label" for="formFieldPerson{{i}}Permanent">Fest</label>
                          </div>
                          <div class="form-check form-switch">
                            <input type="checkbox" class="form-check-input" id="formFieldPerson{{i}}Freelancer"
                                   (change)="changeEmployeeTypes(field, 'FREELANCER')"
                                   [checked]="field.fieldCustomParameter.employeeTypes?.includes('FREELANCER')"
                                   name="formFieldPerson{{i}}Freelancer">
                            <label class="form-check-label" for="formFieldPerson{{i}}Freelancer">Frei</label>
                          </div>
                          <div class="form-check form-switch">
                            <input type="checkbox" class="form-check-input" id="formFieldPerson{{i}}Temporary"
                                   (change)="changeEmployeeTypes(field, 'TEMPORARY')"
                                   [checked]="field.fieldCustomParameter.employeeTypes?.includes('TEMPORARY')"
                                   name="formFieldPerson{{i}}Temporary">
                            <label class="form-check-label" for="formFieldPerson{{i}}Temporary">Aushilfen</label>
                          </div>
                        </div>
                      </div>
                    }
                    @case ('ACCOUNT') {
                      <div class="col-md-6">
                        <div class="form-group mb-2">
                          <label class="data-field-label" for="formFieldAccount{{i}}Min">Mindestanzahl</label>
                          <input type="number" class="form-control form-control-sm" id="formFieldAccount{{i}}Min"
                                 name="formFieldAccount{{i}}Min" min="1" [(ngModel)]="field.fieldCustomParameter.min">
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group mb-2">
                          <label class="data-field-label" for="formFieldAccount{{i}}Max">Maximalanzahl</label>
                          <input type="number" class="form-control form-control-sm" id="formFieldAccount{{i}}Max"
                                 name="formFieldAccount{{i}}Max" min="1" [(ngModel)]="field.fieldCustomParameter.max">
                        </div>
                      </div>
                      <div class="col-12">
                        <span class="small text-secondary d-block mb-3 description-badge"><i class="fas fa-info"></i>&ensp;Wenn min und max nicht befüllt sind, kann nur ein Benutzerkonto ausgewählt werden.</span>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group mb-2">
                          <label class="data-field-label">Rundfunkanstalt / GSEA</label>
                          <div class="form-check form-switch">
                            <input type="checkbox" class="form-check-input" id="formFieldPerson{{i}}rbb"
                                   (change)="changeActiveDirectories(field, 'RBB')"
                                   [checked]="field.fieldCustomParameter.activeDirectories?.includes('RBB')"
                                   name="formFieldPerson{{i}}rbb">
                            <label class="form-check-label" for="formFieldPerson{{i}}rbb">rbb (inkl. POC, Text, GS)</label>
                          </div>
                          <div class="form-check form-switch">
                            <input type="checkbox" class="form-check-input" id="formFieldPerson{{i}}hsb"
                                   (change)="changeActiveDirectories(field, 'HSB')"
                                   [checked]="field.fieldCustomParameter.activeDirectories?.includes('HSB')"
                                   name="formFieldPerson{{i}}hsb">
                            <label class="form-check-label" for="formFieldPerson{{i}}hsb">HSB</label>
                          </div>
                          <div class="form-check form-switch">
                            <input type="checkbox" class="form-check-input" id="formFieldPerson{{i}}ivz"
                                   (change)="changeActiveDirectories(field, 'IVZ')"
                                   [checked]="field.fieldCustomParameter.activeDirectories?.includes('IVZ')"
                                   name="formFieldPerson{{i}}ivz">
                            <label class="form-check-label" for="formFieldPerson{{i}}ivz">IVZ</label>
                          </div>
                        </div>
                      </div>
                    }
                    @case ('PERSON_LIST') {
                      <div class="col-md-6">
                        <div class="form-group mb-2">
                          <label class="data-field-label" for="formFieldPersonList{{i}}Min">Mindestanzahl</label>
                          <input type="number" class="form-control form-control-sm" id="formFieldPersonList{{i}}Min"
                                 name="formFieldPersonList{{i}}Min" min="1" [(ngModel)]="field.fieldCustomParameter.min">
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group mb-2">
                          <label class="data-field-label" for="formFieldPersonList{{i}}Max">Maximalanzahl</label>
                          <input type="number" class="form-control form-control-sm" id="formFieldPersonList{{i}}Max"
                                 name="formFieldPersonList{{i}}Max" min="1" [(ngModel)]="field.fieldCustomParameter.max">
                        </div>
                      </div>
                      <div class="col-12">
                        <span class="small text-secondary d-block mb-3 description-badge"><i class="fas fa-info"></i>&ensp;Min und Max nur ausfüllen, wenn es wirklich benötigt wird.</span>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group mb-2">
                          <label class="data-field-label">Rundfunkanstalt / GSEA</label>
                          <div class="form-check form-switch">
                            <input type="checkbox" class="form-check-input" id="formFieldPersonList{{i}}rbb"
                                   (change)="changeActiveDirectories(field, 'RBB')"
                                   [checked]="field.fieldCustomParameter.activeDirectories?.includes('RBB')"
                                   name="formFieldPersonList{{i}}rbb">
                            <label class="form-check-label" for="formFieldPersonList{{i}}rbb">rbb (inkl. POC, Text, GS)</label>
                          </div>
                          <div class="form-check form-switch">
                            <input type="checkbox" class="form-check-input" id="formFieldPersonList{{i}}hsb"
                                   (change)="changeActiveDirectories(field, 'HSB')"
                                   [checked]="field.fieldCustomParameter.activeDirectories?.includes('HSB')"
                                   name="formFieldPersonList{{i}}hsb">
                            <label class="form-check-label" for="formFieldPersonList{{i}}hsb">HSB</label>
                          </div>
                          <div class="form-check form-switch">
                            <input type="checkbox" class="form-check-input" id="formFieldPersonList{{i}}ivz"
                                   (change)="changeActiveDirectories(field, 'IVZ')"
                                   [checked]="field.fieldCustomParameter.activeDirectories?.includes('IVZ')"
                                   name="formFieldPersonList{{i}}ivz">
                            <label class="form-check-label" for="formFieldPersonList{{i}}ivz">IVZ</label>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group mb-2">
                          <label class="data-field-label">Vertragstyp</label>
                          <div class="form-check form-switch">
                            <input type="checkbox" class="form-check-input" id="formFieldPerson{{i}}Permanent"
                                   (change)="changeEmployeeTypes(field, 'PERMANENT')"
                                   [checked]="field.fieldCustomParameter.employeeTypes?.includes('PERMANENT')"
                                   name="formFieldPerson{{i}}Permanent">
                            <label class="form-check-label" for="formFieldPerson{{i}}Permanent">Fest</label>
                          </div>
                          <div class="form-check form-switch">
                            <input type="checkbox" class="form-check-input" id="formFieldPerson{{i}}Freelancer"
                                   (change)="changeEmployeeTypes(field, 'FREELANCER')"
                                   [checked]="field.fieldCustomParameter.employeeTypes?.includes('FREELANCER')"
                                   name="formFieldPerson{{i}}Freelancer">
                            <label class="form-check-label" for="formFieldPerson{{i}}Freelancer">Frei</label>
                          </div>
                          <div class="form-check form-switch">
                            <input type="checkbox" class="form-check-input" id="formFieldPerson{{i}}Temporary"
                                   (change)="changeEmployeeTypes(field, 'TEMPORARY')"
                                   [checked]="field.fieldCustomParameter.employeeTypes?.includes('TEMPORARY')"
                                   name="formFieldPerson{{i}}Temporary">
                            <label class="form-check-label" for="formFieldPerson{{i}}Temporary">Aushilfen</label>
                          </div>
                        </div>
                      </div>
                    }
                    @case ('PRODUCTION_UNIT') {
                      <div class="col-md-6">
                        <div class="form-group mb-2">
                          <label class="data-field-label" for="formFieldProductionUnit{{i}}Min">Mindestanzahl</label>
                          <input type="number" class="form-control form-control-sm" id="formFieldProductionUnit{{i}}Min"
                                 name="formFieldProductionUnit{{i}}Min" min="1" [(ngModel)]="field.fieldCustomParameter.min">
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group mb-2">
                          <label class="data-field-label" for="formFieldProductionUnit{{i}}Max">Maximalanzahl</label>
                          <input type="number" class="form-control form-control-sm" id="formFieldProductionUnit{{i}}Max"
                                 name="formFieldProductionUnit{{i}}Max" min="1" [(ngModel)]="field.fieldCustomParameter.max">
                        </div>
                      </div>
                      <div class="col-12">
                        <span class="small text-secondary d-block mb-3 description-badge"><i class="fas fa-info"></i>&ensp;Min und Max nur ausfüllen, wenn es wirklich benötigt wird.</span>
                      </div>
                    }
                  }
                  @if (usedConditionalTermsByDefinition(field, i).length) {
                    <div class="col-12">
                      <hr class="my-3">
                    </div>
                    <div class="col-12 text-primary">
                      Das Feld wird in der Bedingungslogik von folgenden Feldern referenziert:
                      <ul>
                        @for (s of usedConditionalTermsByDefinition(field, i); track s) {
                          <li>{{s}}</li>
                        }
                      </ul>
                    </div>
                  }
                </div>
              </div>
            </div>
          }

          <div class="col-md-6 mb-4 text-center" (click)="addField(form.fields?.length)" (keydown.space)="addField(form.fields?.length)" (keydown.enter)="addField(form.fields?.length)" aria-label="Datenfeld hinzufügen"
               tabindex="0">
            <div class="data-field-border p-3 data-field-add" aria-hidden="true">
              <i class="fas fa-plus plus-logo d-block" aria-hidden="true"></i>
            </div>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-12 text-end">
            <button class="btn btn-sm btn-primary" (click)="openModal()">Vorschau anzeigen</button>
            <a class="ms-2 btn btn-sm btn-primary" href="editor-live/{{form.id ?? 'null'}}" target="_blank">Live-Vorschau im neuen Fenster öffnen</a>
          </div>
        </div>
      }
      @case (3) {
        <h4 class="my-3">Datenschutzerklärung</h4>
        <div class="row">
          <h6 class="mt-3">Zweck der Datenverarbeitung</h6>
          <div class="col-md-12">
            <div class="form-group mb-2">
              @if (form.visible) {
                <label for="privacyReason" class="data-field-label">Zweck der Datenverarbeitung beschreiben <sup class="text-primary">*</sup></label>
              }
              <textarea class="form-control" id="privacyReason" rows="3" name="privacyReason" [(ngModel)]="form.privacyReason"></textarea>
              @if (error && form.visible && !form.privacyReason) {
                <div class="text-danger small">
                  Dies ist ein Pflichtfeld.
                </div>
              }
            </div>
          </div>
          <h6 class="mt-3">Verarbeitete Daten</h6>
          <span class="small text-secondary d-block mb-3 description-badge"><i class="fas fa-info"></i>&ensp;Es muss aufgelistet werden, welche personenbezogenen Daten über das Formular verarbeitet werden.</span>
          <div class="col-12">
            <ul>
              <li>Vorname</li>
              <li>Nachname</li>
              <li>AD Benutzername</li>
              <li>ARD UID</li>
              <li>E-Mail-Adresse</li>
              @if (checkTypeInField('EMPLOYEE_NUMBER')) {<li>Personalnummer</li>}
              @if (checkTypeInField('EMPLOYEE_TYPE')) {<li>Vertragsart</li>}
              @if (checkTypeInField('ORG_UNIT')) {<li>Bereich/Abteilung</li>}
              @if (checkTypeInField('MOBILE_WORK_AGREEMENT')) {<li>Vereinbarung zum mobilen Arbeiten</li>}
              @if (checkTypeInField('DISABILITY_STATUS')) {<li>Schwerbehinderung</li>}
              @if (checkTypeInApprover('CHIEF') || checkTypeInApprover('CHIEF_AND_DEPUTY')) {<li>Vorgesetzter (Vorname, Nachname, AD Benutzername, ARD UID, E-Mail-Adresse)</li>}
              @if (checkTypeInApprover('CHIEF_AND_DEPUTY')) {<li>Stellvertretender Vorgesetzter (Vorname, Nachname, AD Benutzername, ARD UID, E-Mail-Adresse)</li>}
              @if (checkTypeInField('COST_CENTRE') || checkTypeInApprover('COST_CENTRE_RESPONSIBLE') || checkTypeInApprover('COST_CENTRE_RESPONSIBLE_AND_DEPUTY')) {<li>Kostenstelle</li>}
              @if (checkTypeInApprover('COST_CENTRE_RESPONSIBLE') || checkTypeInApprover('COST_CENTRE_RESPONSIBLE_AND_DEPUTY')) {<li>Kostenstellenverantwortlicher (Vorname, Nachname, AD Benutzername, ARD UID, E-Mail-Adresse)</li>}
              @if (checkTypeInApprover('COST_CENTRE_RESPONSIBLE_AND_DEPUTY')) {<li>Stellvertretender Kostenstellenverantwortlicher (Vorname, Nachname, AD Benutzername, ARD UID, E-Mail-Adresse)</li>}
              @if (checkTypeInApprover('DEPARTMENT_CHIEF') || checkTypeInApprover('DEPARTMENT_CHIEF_AND_DEPUTY')) {<li>Abteilung</li>}
              @if (checkTypeInApprover('DEPARTMENT_CHIEF') || checkTypeInApprover('DEPARTMENT_CHIEF_AND_DEPUTY')) {<li>Abteilungsleiter (Vorname, Nachname, AD Benutzername, ARD UID, E-Mail-Adresse)</li>}
              @if (checkTypeInApprover('DEPARTMENT_CHIEF_AND_DEPUTY')) {<li>Stellvertretender Abteilungsleiter (Vorname, Nachname, AD Benutzername, ARD UID, E-Mail-Adresse)</li>}
              @if (checkTypeInApprover('MAIN_DEPARTMENT_CHIEF') || checkTypeInApprover('MAIN_DEPARTMENT_CHIEF_AND_DEPUTY')) {<li>Hauptabteilung</li>}
              @if (checkTypeInApprover('MAIN_DEPARTMENT_CHIEF') || checkTypeInApprover('MAIN_DEPARTMENT_CHIEF_AND_DEPUTY')) {<li>Hauptabteilungsleiter (Vorname, Nachname, AD Benutzername, ARD UID, E-Mail-Adresse)</li>}
              @if (checkTypeInApprover('MAIN_DEPARTMENT_CHIEF_AND_DEPUTY')) {<li>Stellvertretender Hauptabteilungsleiter (Vorname, Nachname, AD Benutzername, ARD UID, E-Mail-Adresse)</li>}
              @if (checkTypeInApprover('DIRECTOR') || checkTypeInApprover('DIRECTOR_AND_DEPUTY')) {<li>Direktion</li>}
              @if (checkTypeInApprover('DIRECTOR') || checkTypeInApprover('DIRECTOR_AND_DEPUTY')) {<li>Direktor (Vorname, Nachname, AD Benutzername, ARD UID, E-Mail-Adresse)</li>}
              @if (checkTypeInApprover('DIRECTOR_AND_DEPUTY')) {<li>Stellvertretender Direktor (Vorname, Nachname, AD Benutzername, ARD UID, E-Mail-Adresse)</li>}
              @if (checkTypeInField('ROOM')) {<li>Raumnummer</li>}
              @if (checkTypeInField('ROOM')) {<li>Gebäudename</li>}
              @if (checkTypeInField('ROOM')) {<li>Gebäudeabkürzung</li>}
              @if (checkTypeInField('ROOM')) {<li>Etage</li>}
              @if (checkTypeInField('TELEPHONE')) {<li>Telefonnummer</li>}
              @if (checkTypeInField('FAX')) {<li>Faxnummer</li>}
              @if (checkTypeInField('MOBILE')) {<li>Mobilfunknummer</li>}
            </ul>
            <div class="form-group mb-2">
              <label class="data-field-label">Weitere Datenkategorien</label>
              <div class="row">
                @for (dataField of dataFields; let i = $index; track i) {
                  <div class="col-12">
                    <input type="text" id="dataField{{i}}" name="dataField{{i}}" class="form-control form-control-sm" [(ngModel)]="dataFields[i]">
                  </div>
                }
              </div>
            </div>
            <div class="row">
              <div class="col">
                <hr class="m-0 p-0 hr-custom">
              </div>
              <div class="col-auto">
                <button type="button" class="btn btn-sm btn-outline-success me-2" (click)="addDataField()"
                        aria-label="Datenkategorie hinzufügen"><i class="fas fa-plus" aria-hidden="true"></i></button>
                <button type="button" class="btn btn-sm btn-outline-danger" (click)="removeDataField()"
                        aria-label="Datenkategorie entfernen"><i class="fas fa-minus" aria-hidden="true"></i></button>
              </div>
              <div class="col">
                <hr class="m-0 p-0 hr-custom">
              </div>
            </div>
          </div>
          <h6 class="mt-3">Rechtsgrundlage</h6>
          <span class="small text-secondary d-block mb-3 description-badge"><i class="fas fa-info"></i>&ensp;Für jedes Formular wird der untere Platzhalter-Satz zur Angabe der Rechtsgrundlage genutzt. In den meisten Fällen reicht dies. Falls eine andere Rechtsgrundlage für die Verarbeitung der Daten gilt, wird dies die Datenschutzbeauftragte mitteilen.</span>
          <div class="col-12">
            <div class="form-group mb-2">
              <label for="legalBasis" class="data-field-label">Rechtsgrundlage</label>
              <textarea class="form-control" id="legalBasis" rows="3" name="legalBasis"
                        [(ngModel)]="form.legalBasis" placeholder="Rechtsgrundlage für die Verarbeitung der personenbezogenen Daten ist § 46 rbb-StV i.V.m. § 18 BerlDSG i.V.m. § 26 BDSG bzw. Art. 6 Abs. 1 b) DSGVO für freie Mitarbeiterinnen und Mitarbeiter."></textarea>
            </div>
          </div>
          <h6 class="mt-3">Datenweitergabe</h6>
          <span class="small text-secondary d-block mb-3 description-badge"><i class="fas fa-info"></i>&ensp;Wenn die eingegebenen Daten in andere Systeme innerhalb des rbb übertragen werden, muss dieser Vorgang beschrieben werden. Es muss ebenfalls die Speicherdauer im Zielsystem beschrieben werden. @if (!form.actionType) {Wenn dies nicht der Fall ist, kann das Text-Feld leer gelassen werden und es wird der Platzhalter-Text angezeigt.}</span>
          @if (form.actionType === 'OTRS' || form.actionType === 'OTRS_WEBSERVICE') {<span class="small text-secondary d-block mb-3 description-badge"><i class="fas fa-info"></i>&ensp;Es wurde OTRS als System ausgewählt, an dem die Anträge übertragen werden sollen. Es wird daher ein Standard-Satz eingefügt, der jedoch auch geändert werden kann.</span>}
          <div class="col-12">
            <div class="form-group mb-2">
              <label for="dataTransmission" class="data-field-label">An interne Stellen</label>
              <textarea class="form-control" id="dataTransmission" rows="3" name="dataTransmission"
                        [placeholder]="(form.dataTransmission || form.externalDataTransmission) ? '' : (form.actionType === 'OTRS' || form.actionType === 'OTRS_WEBSERVICE' ? 'Die Daten werden zur weiteren Bearbeitung des Antrags an das OTRS System der HA Mediensysteme und IT geschickt. Für die weitere Verarbeitung der Daten gilt die Datenschutzerklärung von OTRS: https://ardzsd.de/otrs/customer.pl?Action=CustomerFAQZoom;ItemID=1589' : (!form.actionType ? 'Die Daten werden ausschließlich innerhalb der Applikation rbb Forms verarbeitet und nicht an interne oder externe Stellen weitergeleitet.' : ''))"
                        [(ngModel)]="form.dataTransmission"></textarea>
            </div>
          </div>
          <div class="col-12 mt-3">
            <span class="small text-secondary d-block mb-3 description-badge"><i class="fas fa-info"></i>&ensp;Wenn die eingegebenen Daten in andere Systeme außerhalb des rbb übertragen werden oder externe Firmen darauf Zugriff haben, muss dies hier beschrieben werden. Es muss ebenfalls beschrieben werden, wie lang die Speicherdauer beim externen System ist.</span>
            @if (form.actionType === 'OTRS' || form.actionType === 'OTRS_WEBSERVICE') {<span class="small text-secondary d-block mb-3 description-badge"><i class="fas fa-info"></i>&ensp;Es wurde OTRS als System ausgewählt, an dem die Anträge übertragen werden sollen. Es wird daher ein Standard-Satz eingefügt, der jedoch auch geändert werden kann.</span>}
            <div class="form-group mb-2">
              <label for="externalDataTransmission" class="data-field-label">An externe Stellen</label>
              <textarea class="form-control" id="externalDataTransmission" rows="3" name="externalDataTransmission"
                        [placeholder]="(!form.dataTransmission && !form.externalDataTransmission && form.actionType === 'OTRS' || form.actionType === 'OTRS_WEBSERVICE') ? 'Mit der Speicherung des Antrags in OTRS hat auch der zentrale Servicedesk der ARD lesenden Zugriff auf die Daten.' : ''"
                        [(ngModel)]="form.externalDataTransmission"></textarea>
            </div>
          </div>
        </div>

        <h4 class="my-3 pt-3">Vorschau</h4>
        <div class="data-field-border p-3">
          <app-privacy-policy [form]="form"/>
        </div>

      }
      @case (4) {
        @if (oldForm && !isEqual(form, oldForm)) {
          <div class="card mb-3">
            <div class="card-body">
              <h5>Zusammenfassung der Änderungen</h5>
              <app-form-diff [form]="form" [oldForm]="oldForm"/>
            </div>
          </div>
        }
        <app-form [form]="previewForm" [isPreview]="true" [lastApproved]="oldForm"/>
      }
    }
    @if (currentStep !== 4) {
      <div class="col-12 mt-4">
        Felder mit <sup class="text-primary">*</sup> müssen ausgefüllt werden.
      </div>
    }
    <hr class="mt-5">
    @if ((currentStep === 4 && id && id  !== 'new' && (!environment.production || (environment.production && environment.dataProtectionOfficer)))) {
      <div class="alert alert-secondary pointer">
        Wenn Sie große Änderungen an diesem Formular vornehmen, muss die Datenschutzbeauftragte diese Änderung prüfen!<br>
        Bis zur Genehmigung wird die letzte sichtbare Version dieses Formulars aktiv sein.
      </div>
    }
    @if (error) {
      <div class="text-danger my-3">{{error}}</div>
    }
    <div class="my-3">
      <button class="btn btn-danger" routerLink="/editor"><i class="fas fa-times" aria-hidden="true"></i>&ensp;Abbrechen</button>
      @if (currentStep === 4) {
        <button class="btn btn-success ms-3 float-end" (click)="saveForm()">
          <i class="far fa-save" aria-hidden="true"></i>&ensp;Formular speichern
        </button>
      } @else {
        <button class="btn btn-success ms-3 float-end"
                (click)="changeCurrentStep(currentStep +1)">Nächster Schritt&ensp;<i class="fas fa-arrow-right" aria-hidden="true"></i></button>
      }
      @if (currentStep !== 1) {
        <button class="btn btn-secondary ms-3 float-end"
                (click)="changeCurrentStep(currentStep -1)"><i class="fas fa-arrow-left" aria-hidden="true"></i>&ensp;Schritt zurück
        </button>
      }
      @for (system of transferSystems; track system.name) {
        <button class="btn btn-success ms-3 float-end" (click)="transferForm(system.url)">Transfer zu {{system.name}} ({{findIdInOtherSystem(system.url) ? 'Neue Version' : 'Neues Formular'}})</button>
      }
      @if (admin && form.id !== 'new') {
        <button class="btn btn-success ms-3 float-end" (click)="openCopyForm()">
          Als neues Formular kopieren
        </button>
      }
    </div>
  }
</div>

<ng-template #ngModal>
  <div class="modal-header pb-2 pt-2">
    <h5 class="modal-title">
      <span>Vorschau (Einige Funktionen nicht verfügbar)</span>
    </h5>
  </div>
  <div class="modal-body p-3">
    <app-form [form]="previewForm" [isPreview]="true"/>
  </div>
  <div class="modal-footer pb-2 pt-2">
    <button (click)="closeModal()" class="btn btn-secondary btn-sm" type="button">
      <i class="fas fa-times" aria-hidden="true"></i>&ensp;Schließen
    </button>
  </div>
</ng-template>

<ng-template #ngModalCopy>
  <div class="modal-header pb-2 pt-2">
    <h5 class="modal-title">
      <span>Vorschau</span>
    </h5>
  </div>
  <div class="modal-body p-3">
    <div class="input-group input-group-sm mb-3">
      <label class="input-group-text" for="newTag">Neuer Tag</label>
      <input type="text" class="form-control" id="newTag" name="newTag" [(ngModel)]="newTag">
    </div>
  </div>
  <div class="modal-footer pb-2 pt-2">
    <button (click)="copyForm()" class="btn btn-primary btn-sm" type="button" [disabled]="!newTag"><i
      class="far fa-save" aria-hidden="true"></i>&ensp;Speichern
    </button>
    <button (click)="closeCopyForm()" class="btn btn-secondary btn-sm" type="button">
      <i class="fas fa-times" aria-hidden="true"></i>&ensp;Schließen
    </button>
  </div>
</ng-template>

<ng-template #ngModalSave>
  <div class="modal-header pb-2 pt-2">
    <h5 class="modal-title">Formular speichern</h5>
  </div>
  <div class="modal-body p-3">
    <div class="text-center m-auto">
      <rbb-loader/>
      <small class="text-secondary d-block">Formular wird gespeichert und verarbeitet ...</small>
    </div>
  </div>
</ng-template>
